
/* ------------------------------------------------------------------------
 | GENERATED FILE DO NOT MANUALLY EDIT
 | ------------------------------------------------------------------------
 | RUN THE FOLLOWING COMMAND TO REGENERATE FILE:
 | php artisan formeo:permissions:generate:file
 */

/*
 |--------------------------------------------------------------------------
 | Permission Definition Generated File
 |--------------------------------------------------------------------------
 |
 | This file contains definitions of all the permissions used in the
 | system.
 |
 */

/**
 * Permission Definitions
 * @version 2.0
 */
class Permissions {
    // Able to manage a large portion of the system
    static ADMIN_BYPASS = 'admin.bypass';
    // helpdesk.case.view.any
    static HELPDESK_CASE_VIEW_ANY = 'helpdesk.case.view.any';
    // Able to fully manage import blueprint columns
    static IMPORT_BLUEPRINT_COLUMN = 'import_blueprint.column';
    // Able to view all import blueprint columns
    static IMPORT_BLUEPRINT_COLUMN_VIEW_ANY = 'import_blueprint.column.view.any';
    // Able to view a single import blueprint column
    static IMPORT_BLUEPRINT_COLUMN_VIEW_SINGLE = 'import_blueprint.column.view.single';
    // Able to create a import blueprint column
    static IMPORT_BLUEPRINT_COLUMN_CREATE = 'import_blueprint.column.create';
    // Able to update a single import blueprint column
    static IMPORT_BLUEPRINT_COLUMN_UPDATE = 'import_blueprint.column.update';
    // Able to delete a import blueprint column
    static IMPORT_BLUEPRINT_COLUMN_DELETE = 'import_blueprint.column.delete';
    // Able to force delete a import blueprint column
    static IMPORT_BLUEPRINT_COLUMN_FORCE_DELETE = 'import_blueprint.column.force_delete';
    // Able to restore a import blueprint column
    static IMPORT_BLUEPRINT_COLUMN_RESTORE = 'import_blueprint.column.restore';
    // Able to fully manage import blueprints
    static IMPORT_BLUEPRINT = 'import_blueprint';
    // Able to view all import blueprints
    static IMPORT_BLUEPRINT_VIEW_ANY = 'import_blueprint.view.any';
    // Able to view a single import blueprint
    static IMPORT_BLUEPRINT_VIEW_SINGLE = 'import_blueprint.view.single';
    // Able to create a import blueprint
    static IMPORT_BLUEPRINT_CREATE = 'import_blueprint.create';
    // Able to update a single import blueprint
    static IMPORT_BLUEPRINT_UPDATE = 'import_blueprint.update';
    // Able to delete a import blueprint
    static IMPORT_BLUEPRINT_DELETE = 'import_blueprint.delete';
    // Able to force delete a import blueprint
    static IMPORT_BLUEPRINT_FORCE_DELETE = 'import_blueprint.force_delete';
    // Able to restore a import blueprint
    static IMPORT_BLUEPRINT_RESTORE = 'import_blueprint.restore';
    // Able to fully manage imports
    static IMPORT = 'imports';
    // Able to view all imports
    static IMPORT_VIEW_ANY = 'imports.view.any';
    // Able to view a single import
    static IMPORT_VIEW_SINGLE = 'imports.view.single';
    // Able to create a import
    static IMPORT_CREATE = 'imports.create';
    // Able to update a single import
    static IMPORT_UPDATE = 'imports.update';
    // Able to delete a import
    static IMPORT_DELETE = 'imports.delete';
    // Able to force delete a import
    static IMPORT_FORCE_DELETE = 'imports.force_delete';
    // Able to restore a import
    static IMPORT_RESTORE = 'imports.restore';
    // 
    static IMPORT_AVAILABLE_COLUMN = 'imports.available_column';
    // Able to fully manage export blueprints
    static EXPORT_BLUEPRINT = 'export_blueprint';
    // Able to view all export blueprints
    static EXPORT_BLUEPRINT_VIEW_ANY = 'export_blueprint.view.any';
    // Able to view a single export blueprint
    static EXPORT_BLUEPRINT_VIEW_SINGLE = 'export_blueprint.view.single';
    // Able to create a export blueprint
    static EXPORT_BLUEPRINT_CREATE = 'export_blueprint.create';
    // Able to update a single export blueprint
    static EXPORT_BLUEPRINT_UPDATE = 'export_blueprint.update';
    // Able to delete a export blueprint
    static EXPORT_BLUEPRINT_DELETE = 'export_blueprint.delete';
    // Able to force delete a export blueprint
    static EXPORT_BLUEPRINT_FORCE_DELETE = 'export_blueprint.force_delete';
    // Able to restore a export blueprint
    static EXPORT_BLUEPRINT_RESTORE = 'export_blueprint.restore';
    // Able to view export blueprint types
    static EXPORT_BLUEPRINT_TYPES = 'export_blueprint.types';
    // Able to view export blueprint classes
    static EXPORT_BLUEPRINT_CLASSES = 'export_blueprint.classes';
    // Able to view export blueprint tables
    static EXPORT_BLUEPRINT_TABLES = 'export_blueprint.tables';
    // Able to view export blueprint table columns
    static EXPORT_BLUEPRINT_TABLE_COLUMNS = 'export_blueprint.table_columns';
    // Able to fully manage export blueprints query parameters
    static EXPORT_BLUEPRINT_QUERY_PARAMETER = 'export_blueprint.query_parameter';
    // Able to view all export blueprints query parameters
    static EXPORT_BLUEPRINT_QUERY_PARAMETER_VIEW_ANY = 'export_blueprint.query_parameter.view.any';
    // Able to view a single export blueprint query parameter
    static EXPORT_BLUEPRINT_QUERY_PARAMETER_VIEW_SINGLE = 'export_blueprint.query_parameter.view.single';
    // Able to create a export blueprint query parameter
    static EXPORT_BLUEPRINT_QUERY_PARAMETER_CREATE = 'export_blueprint.query_parameter.create';
    // Able to update a single export blueprint query parameter
    static EXPORT_BLUEPRINT_QUERY_PARAMETER_UPDATE = 'export_blueprint.query_parameter.update';
    // Able to delete a export blueprint query parameter
    static EXPORT_BLUEPRINT_QUERY_PARAMETER_DELETE = 'export_blueprint.query_parameter.delete';
    // Able to force delete a export blueprint query parameter
    static EXPORT_BLUEPRINT_QUERY_PARAMETER_FORCE_DELETE = 'export_blueprint.query_parameter.force_delete';
    // Able to restore a export blueprint query parameter
    static EXPORT_BLUEPRINT_QUERY_PARAMETER_RESTORE = 'export_blueprint.query_parameter.restore';
    // Able to view available export blueprint query parameter columns
    static EXPORT_BLUEPRINT_QUERY_PARAMETER_AVAILABLE_COLUMN = 'export_blueprint.query_parameter.available_column';
    // Able to fully manage export blueprints filters
    static EXPORT_BLUEPRINT_FILTER = 'export_blueprint.filter';
    // Able to view all export blueprints filters
    static EXPORT_BLUEPRINT_FILTER_VIEW_ANY = 'export_blueprint.filter.view.any';
    // Able to view a single export blueprint filter
    static EXPORT_BLUEPRINT_FILTER_VIEW_SINGLE = 'export_blueprint.filter.view.single';
    // Able to create a export blueprint filter
    static EXPORT_BLUEPRINT_FILTER_CREATE = 'export_blueprint.filter.create';
    // Able to update a single export blueprint filter
    static EXPORT_BLUEPRINT_FILTER_UPDATE = 'export_blueprint.filter.update';
    // Able to delete a export blueprint filter
    static EXPORT_BLUEPRINT_FILTER_DELETE = 'export_blueprint.filter.delete';
    // Able to force delete a export blueprint filter
    static EXPORT_BLUEPRINT_FILTER_FORCE_DELETE = 'export_blueprint.filter.force_delete';
    // Able to restore a export blueprint filter
    static EXPORT_BLUEPRINT_FILTER_RESTORE = 'export_blueprint.filter.restore';
    // Able to view available export blueprint filter columns
    static EXPORT_BLUEPRINT_FILTER_AVAILABLE_COLUMN = 'export_blueprint.filter.available_column';
    // Able to fully manage exports
    static EXPORTS = 'exports';
    // Able to view all exports
    static EXPORTS_VIEW_ANY = 'exports.view.any';
    // Able to view a single export
    static EXPORTS_VIEW_SINGLE = 'exports.view.single';
    // Able to create a export
    static EXPORTS_CREATE = 'exports.create';
    // Able to update a single export
    static EXPORTS_UPDATE = 'exports.update';
    // Able to delete a export
    static EXPORTS_DELETE = 'exports.delete';
    // Able to force delete a export
    static EXPORTS_FORCE_DELETE = 'exports.force_delete';
    // Able to restore a export
    static EXPORTS_RESTORE = 'exports.restore';
    // 
    static EXPORTS_AVAILABLE_COLUMN = 'exports.available_column';
    // Able to fully manage Suborders
    static SUBORDER_BYPASS = 'suborder.bypass';
    // Able to view all Suborders
    static SUBORDER_VIEW_ALL = 'suborder.view.all';
    // Able to view a single Suborder
    static SUBORDER_VIEW_SINGLE = 'suborder.view.single';
    // Able to create a Suborder
    static SUBORDER_CREATE = 'suborder.create';
    // Able to update a single Suborder
    static SUBORDER_UPDATE = 'suborder.update';
    // Able to delete a Suborder
    static SUBORDER_DELETE = 'suborder.delete';
    // Able to force delete a Suborder
    static SUBORDER_FORCE_DELETE = 'suborder.force_delete';
    // Able to restore a Suborder
    static SUBORDER_RESTORE = 'suborder.restore';
    // Able to fully manage channels
    static CHANNEL = 'channel';
    // Able to manage channel crud
    static CHANNEL_CRUD = 'channel.crud';
    // Able to view all channels
    static CHANNEL_VIEW_ANY = 'channel.view.any';
    // Able to view a single channel
    static CHANNEL_VIEW_SINGLE = 'channel.view.single';
    // Able to view a only assigned single channel
    static CHANNEL_VIEW_ASSIGNED_SINGLE = 'channel.view.assigned.single';
    // Able to create channel
    static CHANNEL_CREATE = 'channel.create';
    // Able to update a channel
    static CHANNEL_UPDATE = 'channel.update';
    // Able to update assigned user channel
    static CHANNEL_UPDATE_ASSIGNED = 'channel.update.assigned';
    // Able to delete a channel
    static CHANNEL_DELETE = 'channel.delete';
    // Able to force delete a channel
    static CHANNEL_FORCE_DELETE = 'channel.force_delete';
    // Able to restore a delete channel
    static CHANNEL_RESTORE = 'channel.restore';
    // Able to use all channel product permissions
    static CHANNEL_PRODUCT = 'channel.product';
    // Able to manage channel product crud
    static CHANNEL_PRODUCT_CRUD = 'channel.product.crud';
    // Able to view all channel products
    static CHANNEL_PRODUCT_VIEW_ANY = 'channel.product.view.any';
    // Able to view all products assigned to user channel
    static CHANNEL_PRODUCT_ASSIGNED_VIEW_ANY = 'channel.product.assigned.view.any';
    // Able to view single channel product
    static CHANNEL_PRODUCT_VIEW_SINGLE = 'channel.product.view.single';
    // Able to view single channel product assigned to user channel
    static CHANNEL_PRODUCT_ASSIGNED_VIEW_SINGLE = 'channel.product.assigned.view.single';
    // Able to create channel product
    static CHANNEL_PRODUCT_CREATE = 'channel.product.create';
    // Able to create product assigned to user channel
    static CHANNEL_PRODUCT_ASSIGNED_CREATE = 'channel.product.assigned.create';
    // Able to update channel product
    static CHANNEL_PRODUCT_UPDATE = 'channel.product.update';
    // Able to update product assigned to user channel
    static CHANNEL_PRODUCT_ASSIGNED_UPDATE = 'channel.product.assigned.update';
    // Able to delete channel product
    static CHANNEL_PRODUCT_DELETE = 'channel.product.delete';
    // Able to delete channel product assigned to user channel
    static CHANNEL_PRODUCT_ASSIGNED_DELETE = 'channel.product.assigned.delete';
    // Able to use all channel product product stock permissions
    static CHANNEL_PRODUCT_PRODUCT_STOCK = 'channel.product.product_stock';
    // Able to view all channel product product stock
    static CHANNEL_PRODUCT_PRODUCT_STOCK_VIEW_ANY = 'channel.product.product_stock.view.any';
    // Able to view single channel product product stock
    static CHANNEL_PRODUCT_PRODUCT_STOCK_VIEW_SINGLE = 'channel.product.product_stock.view.single';
    // Able to use all channel product supply route permissions
    static CHANNEL_PRODUCT_SUPPLY_ROUTE = 'channel.product.supply_route';
    // Able to view all channel product supply route
    static CHANNEL_PRODUCT_SUPPLY_ROUTE_VIEW_ANY = 'channel.product.supply_route.view.any';
    // Able to view single channel product supply route
    static CHANNEL_PRODUCT_SUPPLY_ROUTE_VIEW_SINGLE = 'channel.product.supply_route.view.single';
    // Able to use all channel product variant permissions
    static CHANNEL_PRODUCT_VARIANT = 'channel.product.variant';
    // Able to manage channel product variant crud
    static CHANNEL_PRODUCT_VARIANT_CRUD = 'channel.product.variant.crud';
    // Able to view all channel product variants
    static CHANNEL_PRODUCT_VARIANT_VIEW_ANY = 'channel.product.variant.view.any';
    // Able to view all channel product variants assigned to user channel
    static CHANNEL_PRODUCT_VARIANT_ASSIGNED_VIEW_ANY = 'channel.product.variant.assigned.view.any';
    // Able to view single channel product variant
    static CHANNEL_PRODUCT_VARIANT_VIEW_SINGLE = 'channel.product.variant.view.single';
    // Able to view single channel product variant assigned to user channel
    static CHANNEL_PRODUCT_VARIANT_ASSIGNED_VIEW_SINGLE = 'channel.product.variant.assigned.view.single';
    // Able to create channel product variant
    static CHANNEL_PRODUCT_VARIANT_CREATE = 'channel.product.variant.create';
    // Able to create product assigned to user channel
    static CHANNEL_PRODUCT_VARIANT_ASSIGNED_CREATE = 'channel.product.variant.assigned.create';
    // Able to update channel product variant
    static CHANNEL_PRODUCT_VARIANT_UPDATE = 'channel.product.variant.update';
    // Able to channel product variant update assigned to user channel
    static CHANNEL_PRODUCT_VARIANT_ASSIGNED_UPDATE = 'channel.product.variant.assigned.update';
    // Able to delete channel product variant
    static CHANNEL_PRODUCT_VARIANT_DELETE = 'channel.product.variant.delete';
    // Able to delete channel product variant assigned to user channel
    static CHANNEL_PRODUCT_VARIANT_ASSIGNED_DELETE = 'channel.product.variant.assigned.delete';
    // Able to use all channel attribute permissions
    static CHANNEL_ATTRIBUTE_FAMILY_ATTRIBUTE = 'channel.attribute_family.attribute';
    // Able to view all channel attributes
    static CHANNEL_ATTRIBUTE_FAMILY_ATTRIBUTE_VIEW_ANY = 'channel.attribute_family.attribute.view.any';
    // Able to view all channel attributes assigned to user channel
    static CHANNEL_ATTRIBUTE_FAMILY_ATTRIBUTE_ASSIGNED_VIEW_ANY = 'channel.attribute_family.attribute.assigned.view.any';
    // Able to use all channel attribute family permissions
    static CHANNEL_ATTRIBUTE_FAMILY = 'channel.attribute_family';
    // Able to view all channel attribute families
    static CHANNEL_ATTRIBUTE_FAMILY_VIEW_ANY = 'channel.attribute_family.view.any';
    // Able to view all channel attribute families assigned to user channel
    static CHANNEL_ATTRIBUTE_FAMILY_ASSIGNED_VIEW_ANY = 'channel.attribute_family.assigned.view.any';
    // Able to view single attribute family
    static CHANNEL_ATTRIBUTE_FAMILY_VIEW_SINGLE = 'channel.attribute_family.view.single';
    // Able to view single attribute family assigned to user channel
    static CHANNEL_ATTRIBUTE_FAMILY_ASSIGNED_VIEW_SINGLE = 'channel.attribute_family.assigned.view.single';
    // Able to use all channel order permissions
    static CHANNEL_ORDER = 'channel.order';
    // Able to view all channel orders
    static CHANNEL_ORDER_VIEW_ANY = 'channel.order.view.any';
    // Able to view all channel orders assigned to user channel
    static CHANNEL_ORDER_ASSIGNED_VIEW_ANY = 'channel.order.assigned.view.any';
    // Able to view single channel order
    static CHANNEL_ORDER_VIEW_SINGLE = 'channel.order.view.single';
    // Able to view single channel order assigned to user channel
    static CHANNEL_ORDER_ASSIGNED_VIEW_SINGLE = 'channel.order.assigned.view.single';
    // Able to set a user to the ability to be assigned to a channel
    static CHANNEL_IS_STAFFABLE = 'channel.is_staffable';
    // Able to view all users with CHANNEL_IS_STAFFABLE permission
    static CHANNEL_STAFFABLE_VIEW_ALL = 'channel.staffable.view.all';
    // Able to use all channel staff permissions
    static CHANNEL_STAFF = 'channel.staff';
    // Able to view all channel staff
    static CHANNEL_STAFF_VIEW_ANY = 'channel.staff.view.any';
    // Able to view all channel staff assigned to user
    static CHANNEL_STAFF_ASSIGNED_VIEW_ANY = 'channel.staff.assigned.view.any';
    // Able to attach staff to channel
    static CHANNEL_STAFF_ATTACH = 'channel.staff.attach';
    // Able to attach staff to user assigned channel
    static CHANNEL_STAFF_ASSIGNED_ATTACH = 'channel.staff.assigned.attach';
    // Able to detach staff to channel
    static CHANNEL_STAFF_DETACH = 'channel.staff.detach';
    // Able to detach staff to user assigned channel
    static CHANNEL_STAFF_ASSIGNED_DETACH = 'channel.staff.assigned.detach';
    // Able to use supply routes to channel
    static CHANNEL_SUPPLY_ROUTE = 'channel.supply_route';
    // Able to view supply routes from channel
    static CHANNEL_SUPPLY_ROUTE_VIEW_ANY = 'channel.supply_route.view.any';
    // Able to view supply routes from channel assigned to user
    static CHANNEL_SUPPLY_ROUTE_ASSIGNED_VIEW_ANY = 'channel.supply_route.assigned.view.any';
    // Able to attach supply routes to channel
    static CHANNEL_SUPPLY_ROUTE_ATTACH = 'channel.supply_route.attach';
    // Able to attach supply routes to channel assigned to user
    static CHANNEL_SUPPLY_ROUTE_ASSIGNED_ATTACH = 'channel.supply_route.assigned.attach';
    // Able to detach supply routes from channels
    static CHANNEL_SUPPLY_ROUTE_DETACH = 'channel.supply_route.detach';
    // Able to detach supply routes from channel assigned to user
    static CHANNEL_SUPPLY_ROUTE_ASSIGNED_DETACH = 'channel.supply_route.assigned.detach';
    // Able to use suppliers to channel
    static CHANNEL_SUPPLIER = 'channel.supplier';
    // Able to view suppliers from channel
    static CHANNEL_SUPPLIER_VIEW_ANY = 'channel.supplier.view.any';
    // Able to view suppliers from channel assigned to user
    static CHANNEL_SUPPLIER_ASSIGNED_VIEW_ANY = 'channel.supplier.assigned.view.any';
    // Able to attach suppliers to channel
    static CHANNEL_SUPPLIER_ATTACH = 'channel.supplier.attach';
    // Able to attach suppliers to channel assigned to user
    static CHANNEL_SUPPLIER_ASSIGNED_ATTACH = 'channel.supplier.assigned.attach';
    // Able to detach suppliers from channels
    static CHANNEL_SUPPLIER_DETACH = 'channel.supplier.detach';
    // Able to detach suppliers from channel assigned to user
    static CHANNEL_SUPPLIER_ASSIGNED_DETACH = 'channel.supplier.assigned.detach';
    // Able to use order types to channel
    static CHANNEL_ORDER_TYPE = 'channel.order_type';
    // Able to attach order types to channel
    static CHANNEL_ORDER_TYPE_ATTACH = 'channel.order_type.attach';
    // Able to attach order types to channel assigned to user
    static CHANNEL_ORDER_TYPE_ASSIGNED_ATTACH = 'channel.order_type.assigned.attach';
    // Able to detach order types from channels
    static CHANNEL_ORDER_TYPE_DETACH = 'channel.order_type.detach';
    // Able to detach order types from channel assigned to user
    static CHANNEL_ORDER_TYPE_ASSIGNED_DETACH = 'channel.order_type.assigned.detach';
    // Able to use all channel formulary permissions
    static CHANNEL_FORMULARY = 'channel.formulary';
    // Able to manage channel formularies crud
    static CHANNEL_FORMULARY_CRUD = 'channel.formulary.crud';
    // Able to view all channel formularies
    static CHANNEL_FORMULARY_VIEW_ANY = 'channel.formulary.view.any';
    // Able to view all channel assigned to user formularies
    static CHANNEL_FORMULARY_ASSIGNED_VIEW_ANY = 'channel.formulary.assigned.view.any';
    // Able to view single channel formulary
    static CHANNEL_FORMULARY_VIEW_SINGLE = 'channel.formulary.view.single';
    // Able to view single channel assigned to user formulary
    static CHANNEL_FORMULARY_ASSIGNED_VIEW_SINGLE = 'channel.formulary.assigned.view.single';
    // Able to create channel formulary
    static CHANNEL_FORMULARY_CREATE = 'channel.formulary.create';
    // Able to create channel assigned to user formulary
    static CHANNEL_FORMULARY_ASSIGNED_CREATE = 'channel.formulary.assigned.create';
    // Able to update channel formulary
    static CHANNEL_FORMULARY_UPDATE = 'channel.formulary.update';
    // Able to update channel assigned to user formulary
    static CHANNEL_FORMULARY_ASSIGNED_UPDATE = 'channel.formulary.assigned.update';
    // Able to delete channel formulary
    static CHANNEL_FORMULARY_DELETE = 'channel.formulary.delete';
    // Able to delete channel assigned to user formulary
    static CHANNEL_FORMULARY_ASSIGNED_DELETE = 'channel.formulary.assigned.delete';
    // 
    static CHANNEL_FORMULARY_FORCE_DELETE = 'channel.formulary.force_delete';
    // 
    static CHANNEL_FORMULARY_ASSIGNED_FORCE_DELETE = 'channel.formulary.assigned.force_delete';
    // 
    static CHANNEL_FORMULARY_RESTORE = 'channel.formulary.restore';
    // 
    static CHANNEL_FORMULARY_ASSIGNED_RESTORE = 'channel.formulary.assigned.restore';
    // Able to use all channel formulary products permissions
    static CHANNEL_FORMULARY_PRODUCT = 'channel.formulary.product';
    // Able to view all channel formularies products
    static CHANNEL_FORMULARY_PRODUCT_CRUD = 'channel.formulary.product.view.any';
    // Able to view all channel formularies products
    static CHANNEL_FORMULARY_PRODUCT_VIEW_ANY = 'channel.formulary.product.view.any';
    // Able to view all channel assigned to user formularies products
    static CHANNEL_FORMULARY_PRODUCT_ASSIGNED_VIEW_ANY = 'channel.formulary.product.assigned.view.any';
    // Able to view single channel formulary product
    static CHANNEL_FORMULARY_PRODUCT_VIEW_SINGLE = 'channel.formulary.product.view.single';
    // Able to view single channel assigned to user formulary product
    static CHANNEL_FORMULARY_PRODUCT_ASSIGNED_VIEW_SINGLE = 'channel.formulary.product.assigned.view.single';
    // Able to create channel formulary products
    static CHANNEL_FORMULARY_PRODUCT_CREATE = 'channel.formulary.product.create';
    // Able to create channel assigned to user formulary products
    static CHANNEL_FORMULARY_PRODUCT_ASSIGNED_CREATE = 'channel.formulary.product.assigned.create';
    // Able to update channel formulary products
    static CHANNEL_FORMULARY_PRODUCT_UPDATE = 'channel.formulary.product.update';
    // Able to update channel assigned to user formulary products
    static CHANNEL_FORMULARY_PRODUCT_ASSIGNED_UPDATE = 'channel.formulary.product.assigned.update';
    // Able to delete channel formulary products
    static CHANNEL_FORMULARY_PRODUCT_DELETE = 'channel.formulary.product.delete';
    // Able to delete channel assigned to user formulary products
    static CHANNEL_FORMULARY_PRODUCT_ASSIGNED_DELETE = 'channel.formulary.product.assigned.delete';
    // 
    static CHANNEL_FORMULARY_PRODUCT_FORCE_DELETE = 'channel.formulary.product.force_delete';
    // 
    static CHANNEL_FORMULARY_PRODUCT_ASSIGNED_FORCE_DELETE = 'channel.formulary.product.assigned.force_delete';
    // 
    static CHANNEL_FORMULARY_PRODUCT_RESTORE = 'channel.formulary.product.restore';
    // 
    static CHANNEL_FORMULARY_PRODUCT_ASSIGNED_RESTORE = 'channel.formulary.product.assigned.restore';
    // Able to use all channel formulary classifications permissions
    static CHANNEL_FORMULARY_CLASSIFICATION = 'channel.formulary.classification';
    // Able to manage channel formularies classification crud
    static CHANNEL_FORMULARY_CLASSIFICATION_CRUD = 'channel.formulary.classification.crud';
    // Able to view all channel formularies classifications
    static CHANNEL_FORMULARY_CLASSIFICATION_VIEW_ANY = 'channel.formulary.classification.view.any';
    // Able to view all channel assigned to user formularies classifications
    static CHANNEL_FORMULARY_CLASSIFICATION_ASSIGNED_VIEW_ANY = 'channel.formulary.classification.assigned.view.any';
    // Able to view single channel formulary classification
    static CHANNEL_FORMULARY_CLASSIFICATION_VIEW_SINGLE = 'channel.formulary.classification.view.single';
    // Able to view single channel assigned to user formulary classification
    static CHANNEL_FORMULARY_CLASSIFICATION_ASSIGNED_VIEW_SINGLE = 'channel.formulary.classification.assigned.view.single';
    // Able to create channel formulary classifications
    static CHANNEL_FORMULARY_CLASSIFICATION_CREATE = 'channel.formulary.classification.create';
    // Able to create channel assigned to user formulary classifications
    static CHANNEL_FORMULARY_CLASSIFICATION_ASSIGNED_CREATE = 'channel.formulary.classification.assigned.create';
    // Able to update channel formulary classifications
    static CHANNEL_FORMULARY_CLASSIFICATION_UPDATE = 'channel.formulary.classification.update';
    // Able to update channel assigned to user formulary classifications
    static CHANNEL_FORMULARY_CLASSIFICATION_ASSIGNED_UPDATE = 'channel.formulary.classification.assigned.update';
    // Able to delete channel formulary classifications
    static CHANNEL_FORMULARY_CLASSIFICATION_DELETE = 'channel.formulary.classification.delete';
    // Able to delete channel assigned to user formulary classifications
    static CHANNEL_FORMULARY_CLASSIFICATION_ASSIGNED_DELETE = 'channel.formulary.classification.assigned.delete';
    // Able to force delete channel formulary classifications
    static CHANNEL_FORMULARY_CLASSIFICATION_FORCE_DELETE = 'channel.formulary.classification.force_delete';
    // Able to force delete channel assigned to user formulary classifications
    static CHANNEL_FORMULARY_CLASSIFICATION_ASSIGNED_FORCE_DELETE = 'channel.formulary.classification.assigned.force_delete';
    // Able to restore channel formulary classifications
    static CHANNEL_FORMULARY_CLASSIFICATION_RESTORE = 'channel.formulary.classification.restore';
    // Able to restore channel assigned to user formulary classifications
    static CHANNEL_FORMULARY_CLASSIFICATION_ASSIGNED_RESTORE = 'channel.formulary.classification.assigned.restore';
    // Able to use all channel formulary classification products permissions
    static CHANNEL_FORMULARY_CLASSIFICATION_PRODUCT = 'channel.formulary.classification.product';
    // Able to manage channel formularies classification product crud
    static CHANNEL_FORMULARY_CLASSIFICATION_PRODUCT_CRUD = 'channel.formulary.classification.product.crud';
    // Able to view all channel formularies classification products
    static CHANNEL_FORMULARY_CLASSIFICATION_PRODUCT_VIEW_ANY = 'channel.formulary.classification.product.view.any';
    // Able to view all channel assigned to user formularies classification products
    static CHANNEL_FORMULARY_CLASSIFICATION_PRODUCT_ASSIGNED_VIEW_ANY = 'channel.formulary.classification.product.assigned.view.any';
    // Able to view single channel formulary classification product
    static CHANNEL_FORMULARY_CLASSIFICATION_PRODUCT_VIEW_SINGLE = 'channel.formulary.classification.product.view.single';
    // Able to view single channel assigned to user formulary classification product
    static CHANNEL_FORMULARY_CLASSIFICATION_PRODUCT_ASSIGNED_VIEW_SINGLE = 'channel.formulary.classification.product.assigned.view.single';
    // Able to create channel formulary classification products
    static CHANNEL_FORMULARY_CLASSIFICATION_PRODUCT_CREATE = 'channel.formulary.classification.product.create';
    // Able to create channel assigned to user formulary classification products
    static CHANNEL_FORMULARY_CLASSIFICATION_PRODUCT_ASSIGNED_CREATE = 'channel.formulary.classification.product.assigned.create';
    // Able to update channel formulary classification products
    static CHANNEL_FORMULARY_CLASSIFICATION_PRODUCT_UPDATE = 'channel.formulary.classification.product.update';
    // Able to update channel assigned to user formulary classification products
    static CHANNEL_FORMULARY_CLASSIFICATION_PRODUCT_ASSIGNED_UPDATE = 'channel.formulary.classification.product.assigned.update';
    // Able to delete channel formulary classification products
    static CHANNEL_FORMULARY_CLASSIFICATION_PRODUCT_DELETE = 'channel.formulary.classification.product.delete';
    // Able to delete channel assigned to user formulary classification products
    static CHANNEL_FORMULARY_CLASSIFICATION_PRODUCT_ASSIGNED_DELETE = 'channel.formulary.classification.product.assigned.delete';
    // Able to force delete channel formulary classification products
    static CHANNEL_FORMULARY_CLASSIFICATION_PRODUCT_FORCE_DELETE = 'channel.formulary.classification.product.force_delete';
    // Able to force delete channel assigned to user formulary classification products
    static CHANNEL_FORMULARY_CLASSIFICATION_PRODUCT_ASSIGNED_FORCE_DELETE = 'channel.formulary.classification.product.assigned.force_delete';
    // Able to restore channel formulary classification products
    static CHANNEL_FORMULARY_CLASSIFICATION_PRODUCT_RESTORE = 'channel.formulary.classification.product.restore';
    // Able to restore channel assigned to user formulary classification products
    static CHANNEL_FORMULARY_CLASSIFICATION_PRODUCT_ASSIGNED_RESTORE = 'channel.formulary.classification.product.assigned.restore';
    // Able to use all channel formulary formulary classification products permissions
    static CHANNEL_FORMULARY_FORMULARY_CLASSIFICATION_PRODUCT = 'channel.formulary.formulary.classification.product';
    // Able to manage channel formularies classification product crud
    static CHANNEL_FORMULARY_FORMULARY_CLASSIFICATION_PRODUCT_CRUD = 'channel.formulary.formulary.classification.product.crud';
    // Able to view all channel formularies classification products
    static CHANNEL_FORMULARY_FORMULARY_CLASSIFICATION_PRODUCT_VIEW_ANY = 'channel.formulary.formulary.classification.product.view.any';
    // Able to view all channel assigned to user formularies classification products
    static CHANNEL_FORMULARY_FORMULARY_CLASSIFICATION_PRODUCT_ASSIGNED_VIEW_ANY = 'channel.formulary.formulary.classification.product.assigned.view.any';
    // Able to view single channel formulary formulary classification product
    static CHANNEL_FORMULARY_FORMULARY_CLASSIFICATION_PRODUCT_VIEW_SINGLE = 'channel.formulary.formulary.classification.product.view.single';
    // Able to view single channel assigned to user formulary formulary classification product
    static CHANNEL_FORMULARY_FORMULARY_CLASSIFICATION_PRODUCT_ASSIGNED_VIEW_SINGLE = 'channel.formulary.formulary.classification.product.assigned.view.single';
    // Able to create channel formulary formulary classification products
    static CHANNEL_FORMULARY_FORMULARY_CLASSIFICATION_PRODUCT_CREATE = 'channel.formulary.formulary.classification.product.create';
    // Able to create channel assigned to user formulary formulary classification products
    static CHANNEL_FORMULARY_FORMULARY_CLASSIFICATION_PRODUCT_ASSIGNED_CREATE = 'channel.formulary.formulary.classification.product.assigned.create';
    // Able to update channel formulary formulary classification products
    static CHANNEL_FORMULARY_FORMULARY_CLASSIFICATION_PRODUCT_UPDATE = 'channel.formulary.formulary.classification.product.update';
    // Able to update channel assigned to user formulary formulary classification products
    static CHANNEL_FORMULARY_FORMULARY_CLASSIFICATION_PRODUCT_ASSIGNED_UPDATE = 'channel.formulary.formulary.classification.product.assigned.update';
    // Able to delete channel formulary formulary classification products
    static CHANNEL_FORMULARY_FORMULARY_CLASSIFICATION_PRODUCT_DELETE = 'channel.formulary.formulary.classification.product.delete';
    // Able to delete channel assigned to user formulary formulary classification products
    static CHANNEL_FORMULARY_FORMULARY_CLASSIFICATION_PRODUCT_ASSIGNED_DELETE = 'channel.formulary.formulary.classification.product.assigned.delete';
    // Able to force delete channel formulary formulary classification products
    static CHANNEL_FORMULARY_FORMULARY_CLASSIFICATION_PRODUCT_FORCE_DELETE = 'channel.formulary.formulary.classification.product.force_delete';
    // Able to force delete channel assigned to user formulary formulary classification products
    static CHANNEL_FORMULARY_FORMULARY_CLASSIFICATION_PRODUCT_ASSIGNED_FORCE_DELETE = 'channel.formulary.formulary.classification.product.assigned.force_delete';
    // Able to restore channel formulary formulary classification products
    static CHANNEL_FORMULARY_FORMULARY_CLASSIFICATION_PRODUCT_RESTORE = 'channel.formulary.formulary.classification.product.restore';
    // Able to restore channel assigned to user formulary formulary classification products
    static CHANNEL_FORMULARY_FORMULARY_CLASSIFICATION_PRODUCT_ASSIGNED_RESTORE = 'channel.formulary.formulary.classification.product.assigned.restore';
    // Able to use all channel formulary formulary classifications permissions
    static CHANNEL_FORMULARY_FORMULARY_CLASSIFICATION = 'channel.formulary.formulary.classification';
    // Able to view manage channel formularies formulary classification crud
    static CHANNEL_FORMULARY_FORMULARY_CLASSIFICATION_CRUD = 'channel.formulary.formulary.classification.crud';
    // Able to view all channel formularies formulary classifications
    static CHANNEL_FORMULARY_FORMULARY_CLASSIFICATION_VIEW_ANY = 'channel.formulary.formulary.classification.view.any';
    // Able to view all channel assigned to user formularies formulary classifications
    static CHANNEL_FORMULARY_FORMULARY_CLASSIFICATION_ASSIGNED_VIEW_ANY = 'channel.formulary.formulary.classification.assigned.view.any';
    // Able to view single channel formulary formulary classification
    static CHANNEL_FORMULARY_FORMULARY_CLASSIFICATION_VIEW_SINGLE = 'channel.formulary.formulary.classification.view.single';
    // Able to view single channel assigned to user formulary formulary classification
    static CHANNEL_FORMULARY_FORMULARY_CLASSIFICATION_ASSIGNED_VIEW_SINGLE = 'channel.formulary.formulary.classification.assigned.view.single';
    // Able to create channel formulary formulary classifications
    static CHANNEL_FORMULARY_FORMULARY_CLASSIFICATION_CREATE = 'channel.formulary.formulary.classification.create';
    // Able to create channel assigned to user formulary formulary classifications
    static CHANNEL_FORMULARY_FORMULARY_CLASSIFICATION_ASSIGNED_CREATE = 'channel.formulary.formulary.classification.assigned.create';
    // Able to update channel formulary formulary classifications
    static CHANNEL_FORMULARY_FORMULARY_CLASSIFICATION_UPDATE = 'channel.formulary.formulary.classification.update';
    // Able to update channel assigned to user formulary formulary classifications
    static CHANNEL_FORMULARY_FORMULARY_CLASSIFICATION_ASSIGNED_UPDATE = 'channel.formulary.formulary.classification.assigned.update';
    // Able to delete channel formulary formulary classifications
    static CHANNEL_FORMULARY_FORMULARY_CLASSIFICATION_DELETE = 'channel.formulary.formulary.classification.delete';
    // Able to delete channel assigned to user formulary formulary classifications
    static CHANNEL_FORMULARY_FORMULARY_CLASSIFICATION_ASSIGNED_DELETE = 'channel.formulary.formulary.classification.assigned.delete';
    // 
    static CHANNEL_FORMULARY_FORMULARY_CLASSIFICATION_FORCE_DELETE = 'channel.formulary.formulary.classification.force_delete';
    // 
    static CHANNEL_FORMULARY_FORMULARY_CLASSIFICATION_ASSIGNED_FORCE_DELETE = 'channel.formulary.formulary.classification.assigned.force_delete';
    // 
    static CHANNEL_FORMULARY_FORMULARY_CLASSIFICATION_RESTORE = 'channel.formulary.formulary.classification.restore';
    // 
    static CHANNEL_FORMULARY_FORMULARY_CLASSIFICATION_ASSIGNED_RESTORE = 'channel.formulary.formulary.classification.assigned.restore';
    // Able to view all available ccgs
    static CHANNEL_CCG_AVAILABLE = 'channel.ccg.available';
    // Able to view all available formulary products
    static CHANNEL_FORMULARY_PRODUCT_AVAILABLE = 'channel.formulary_product.available';
    // Able to add formulary products in bulk
    static CHANNEL_FORMULARY_PRODUCT_BULK = 'channel.formulary_product.bulk';
    // Able to view all formulary classification products
    static CHANNEL_FORMULARY_CLASSIFICATION_PRODUCT_AVAILABLE = 'channel.formulary_classification_product.available';
    // Able to add formulary classification products in bulk
    static CHANNEL_FORMULARY_CLASSIFICATION_PRODUCT_BULK = 'channel.formulary_classification_product.bulk';
    // Able to view all channel location formulary classifications
    static CHANNEL_LOCATION_FORMULARY_CLASSIFICATION_VIEW_ANY = 'channel.location.formulary_classification.view.any';
    // Able to view all channel location formulary classifications for assigned channels
    static CHANNEL_LOCATION_FORMULARY_CLASSIFICATION_ASSIGNED_VIEW_ANY = 'channel.location.formulary_classification.assigned.view.any';
    // Able to use all channel location formulary classification product overrides permissions
    static CHANNEL_LOCATION_FORMULARY_CLASSIFICATION_PRODUCT_OVERRIDE = 'channel.location.formulary_classification_product_override';
    // Able to view manage channel location formulary classification product override crud
    static CHANNEL_LOCATION_FORMULARY_CLASSIFICATION_PRODUCT_OVERRIDE_CRUD = 'channel.location.formulary_classification_product_override.crud';
    // Able to view all channel location formulary classification product overrides
    static CHANNEL_LOCATION_FORMULARY_CLASSIFICATION_PRODUCT_OVERRIDE_VIEW_ANY = 'channel.location.formulary_classification_product_override.view.any';
    // Able to view single channel location formulary classification product override
    static CHANNEL_LOCATION_FORMULARY_CLASSIFICATION_PRODUCT_OVERRIDE_VIEW_SINGLE = 'channel.location.formulary_classification_product_override.view.single';
    // Able to create channel location formulary classification product override
    static CHANNEL_LOCATION_FORMULARY_CLASSIFICATION_PRODUCT_OVERRIDE_CREATE = 'channel.location.formulary_classification_product_override.create';
    // Able to update channel location formulary classification product override
    static CHANNEL_LOCATION_FORMULARY_CLASSIFICATION_PRODUCT_OVERRIDE_UPDATE = 'channel.location.formulary_classification_product_override.update';
    // Able to delete channel location formulary classification product override
    static CHANNEL_LOCATION_FORMULARY_CLASSIFICATION_PRODUCT_OVERRIDE_DELETE = 'channel.location.formulary_classification_product_override.delete';
    // Able to view all channel location formulary classification product overrides for assigned channels
    static CHANNEL_LOCATION_FORMULARY_CLASSIFICATION_PRODUCT_OVERRIDE_ASSIGNED_VIEW_ANY = 'channel.location.formulary_classification_product_override.assigned.view.any';
    // Able to use all channel ccg supply route permissions
    static CHANNEL_CCG_SUPPLY_ROUTES = 'channel.ccg.supply_route';
    // Able to manage channel ccg supply route crud
    static CHANNEL_CCG_SUPPLY_ROUTES_CRUD = 'channel.ccg.supply_route.crud';
    // Able to view all channel ccg supply routes
    static CHANNEL_CCG_SUPPLY_ROUTES_VIEW_ANY = 'channel.ccg.supply_route.view.any';
    // Able to view all channel assigned to user ccg supply routes
    static CHANNEL_CCG_SUPPLY_ROUTES_ASSIGNED_VIEW_ANY = 'channel.ccg.supply_route.assigned.view.any';
    // Able to view single channel formulary formulary classification product
    static CHANNEL_CCG_SUPPLY_ROUTES_VIEW_SINGLE = 'channel.ccg.supply_route.view.single';
    // Able to view single channel assigned to user formulary formulary classification product
    static CHANNEL_CCG_SUPPLY_ROUTES_ASSIGNED_VIEW_SINGLE = 'channel.ccg.supply_route.assigned.view.single';
    // Able to create channel ccg supply route
    static CHANNEL_CCG_SUPPLY_ROUTES_CREATE = 'channel.ccg.supply_route.create';
    // Able to create channel assigned to user ccg supply route
    static CHANNEL_CCG_SUPPLY_ROUTES_ASSIGNED_CREATE = 'channel.ccg.supply_route.assigned.create';
    // Able to update channel ccg supply route
    static CHANNEL_CCG_SUPPLY_ROUTES_UPDATE = 'channel.ccg.supply_route.update';
    // Able to update channel assigned to user ccg supply route
    static CHANNEL_CCG_SUPPLY_ROUTES_ASSIGNED_UPDATE = 'channel.ccg.supply_route.assigned.update';
    // Able to delete channel ccg supply route
    static CHANNEL_CCG_SUPPLY_ROUTES_DELETE = 'channel.ccg.supply_route.delete';
    // Able to delete channel assigned to user ccg supply route
    static CHANNEL_CCG_SUPPLY_ROUTES_ASSIGNED_DELETE = 'channel.ccg.supply_route.assigned.delete';
    // Able to force delete channel ccg supply route
    static CHANNEL_CCG_SUPPLY_ROUTES_FORCE_DELETE = 'channel.ccg.supply_route.force_delete';
    // Able to force delete channel assigned to user ccg supply route
    static CHANNEL_CCG_SUPPLY_ROUTES_ASSIGNED_FORCE_DELETE = 'channel.ccg.supply_route.assigned.force_delete';
    // Able to restore channel ccg supply route
    static CHANNEL_CCG_SUPPLY_ROUTES_RESTORE = 'channel.ccg.supply_route.restore';
    // Able to restore channel assigned to user ccg supply route
    static CHANNEL_CCG_SUPPLY_ROUTES_ASSIGNED_RESTORE = 'channel.ccg.supply_route.assigned.restore';
    // Able to use all channel ccg supplier permissions
    static CHANNEL_CCG_SUPPLIERS = 'channel.ccg.supplier';
    // Able to manage channel ccg supplier crud
    static CHANNEL_CCG_SUPPLIERS_CRUD = 'channel.ccg.supplier.crud';
    // Able to view all channel ccg suppliers
    static CHANNEL_CCG_SUPPLIERS_VIEW_ANY = 'channel.ccg.supplier.view.any';
    // Able to view all channel assigned to user ccg suppliers
    static CHANNEL_CCG_SUPPLIERS_ASSIGNED_VIEW_ANY = 'channel.ccg.supplier.assigned.view.any';
    // Able to view single channel formulary formulary classification product
    static CHANNEL_CCG_SUPPLIERS_VIEW_SINGLE = 'channel.ccg.supplier.view.single';
    // Able to view single channel assigned to user formulary formulary classification product
    static CHANNEL_CCG_SUPPLIERS_ASSIGNED_VIEW_SINGLE = 'channel.ccg.supplier.assigned.view.single';
    // Able to create channel ccg supplier
    static CHANNEL_CCG_SUPPLIERS_CREATE = 'channel.ccg.supplier.create';
    // Able to create channel assigned to user ccg supplier
    static CHANNEL_CCG_SUPPLIERS_ASSIGNED_CREATE = 'channel.ccg.supplier.assigned.create';
    // Able to update channel ccg supplier
    static CHANNEL_CCG_SUPPLIERS_UPDATE = 'channel.ccg.supplier.update';
    // Able to update channel assigned to user ccg supplier
    static CHANNEL_CCG_SUPPLIERS_ASSIGNED_UPDATE = 'channel.ccg.supplier.assigned.update';
    // Able to delete channel ccg supplier
    static CHANNEL_CCG_SUPPLIERS_DELETE = 'channel.ccg.supplier.delete';
    // Able to delete channel assigned to user ccg supplier
    static CHANNEL_CCG_SUPPLIERS_ASSIGNED_DELETE = 'channel.ccg.supplier.assigned.delete';
    // Able to force delete channel ccg supplier
    static CHANNEL_CCG_SUPPLIERS_FORCE_DELETE = 'channel.ccg.supplier.force_delete';
    // Able to force delete channel assigned to user ccg supplier
    static CHANNEL_CCG_SUPPLIERS_ASSIGNED_FORCE_DELETE = 'channel.ccg.supplier.assigned.force_delete';
    // Able to restore channel ccg supplier
    static CHANNEL_CCG_SUPPLIERS_RESTORE = 'channel.ccg.supplier.restore';
    // Able to restore channel assigned to user ccg supplier
    static CHANNEL_CCG_SUPPLIERS_ASSIGNED_RESTORE = 'channel.ccg.supplier.assigned.restore';
    // Able to use all channel ccg location formulary classification product overrides permissions
    static CHANNEL_CCG_LOCATION_FORMULARY_CLASSIFICATION_PRODUCT_OVERRIDE = 'channel.ccg.location.formulary_classification_product_override';
    // Able to view manage channel ccg location formulary classification product override crud
    static CHANNEL_CCG_LOCATION_FORMULARY_CLASSIFICATION_PRODUCT_OVERRIDE_CRUD = 'channel.ccg.location.formulary_classification_product_override.crud';
    // Able to view all channel ccg location formulary classification product overrides
    static CHANNEL_CCG_LOCATION_FORMULARY_CLASSIFICATION_PRODUCT_OVERRIDE_VIEW_ANY = 'channel.ccg.location.formulary_classification_product_override.view.any';
    // Able to view single channel ccg location formulary classification product override
    static CHANNEL_CCG_LOCATION_FORMULARY_CLASSIFICATION_PRODUCT_OVERRIDE_VIEW_SINGLE = 'channel.ccg.location.formulary_classification_product_override.view.single';
    // Able to create channel ccg location formulary classification product override
    static CHANNEL_CCG_LOCATION_FORMULARY_CLASSIFICATION_PRODUCT_OVERRIDE_CREATE = 'channel.ccg.location.formulary_classification_product_override.create';
    // Able to update channel ccg location formulary classification product override
    static CHANNEL_CCG_LOCATION_FORMULARY_CLASSIFICATION_PRODUCT_OVERRIDE_UPDATE = 'channel.ccg.location.formulary_classification_product_override.update';
    // Able to delete channel ccg location formulary classification product override
    static CHANNEL_CCG_LOCATION_FORMULARY_CLASSIFICATION_PRODUCT_OVERRIDE_DELETE = 'channel.ccg.location.formulary_classification_product_override.delete';
    // Able to use all ccg formulary permissions
    static CCG_FORMULARY = 'ccg.formulary';
    // Able to manage all ccg formulary crud
    static CCG_FORMULARY_CRUD = 'ccg.formulary.crud';
    // Able to view all ccg formularies
    static CCG_FORMULARY_VIEW_ANY = 'ccg.formulary.view.any';
    // Able to view single ccg formulary
    static CCG_FORMULARY_VIEW_SINGLE = 'ccg.formulary.view.single';
    // Able to create ccg formulary
    static CCG_FORMULARY_CREATE = 'ccg.formulary.create';
    // Able to update ccg formulary
    static CCG_FORMULARY_UPDATE = 'ccg.formulary.update';
    // Able to delete ccg formulary
    static CCG_FORMULARY_DELETE = 'ccg.formulary.delete';
    // Able to use all channel ccg formulary permissions
    static CHANNEL_CCG_FORMULARY = 'channel.ccg.formulary';
    // Able to manage all channel ccg formulary crud
    static CHANNEL_CCG_FORMULARY_CRUD = 'channel.ccg.formulary.crud';
    // Able to view all channel ccg formularies
    static CHANNEL_CCG_FORMULARY_VIEW_ANY = 'channel.ccg.formulary.view.any';
    // Able to view single channel ccg formulary
    static CHANNEL_CCG_FORMULARY_VIEW_SINGLE = 'channel.ccg.formulary.view.single';
    // Able to create channel ccg formulary
    static CHANNEL_CCG_FORMULARY_CREATE = 'channel.ccg.formulary.create';
    // Able to update ccg formulary from channel
    static CHANNEL_CCG_FORMULARY_UPDATE = 'channel.ccg.formulary.update';
    // Able to delete channel ccg formulary
    static CHANNEL_CCG_FORMULARY_DELETE = 'channel.ccg.formulary.delete';
    // Able to use all ccg supply route permissions
    static CCG_SUPPLY_ROUTE = 'ccg.supply_route';
    // Able to view all ccg supply routes
    static CCG_SUPPLY_ROUTE_VIEW_ANY = 'ccg.supply_route.view.any';
    // Able to attach ccg supply routes
    static CCG_SUPPLY_ROUTE_ATTACH = 'ccg.supply_route.attach';
    // Able to detach ccg supply routes
    static CCG_SUPPLY_ROUTE_DETACH = 'ccg.supply_route.detach';
    // Able to update ccg supply route pivot
    static CCG_SUPPLY_ROUTE_UPDATE = 'ccg.supply_route.update';
    // Able to view all available supply routes
    static CCG_SUPPLY_ROUTE_AVAILABLE = 'ccg.supply_route.available';
    // Able to view all available suppliers
    static CCG_SUPPLIER_AVAILABLE = 'ccg.supplier.available';
    // Able to use all ccg channel permissions
    static CCG_CHANNEL = 'ccg.channel';
    // Able to manage all ccg channel crud
    static CCG_CHANNEL_VIEW_ANY = 'ccg.channel.view.any';
    // Able to view single ccg channel
    static CCG_CHANNEL_VIEW_SINGLE = 'ccg.channel.view.single';
    // Able to attach ccg to channel
    static CCG_CHANNEL_ATTACH = 'ccg.channel.attach';
    // Able to detach ccg to channel
    static CCG_CHANNEL_DETACH = 'ccg.channel.detach';
    // Able to use all ccg channel formulary permissions
    static CCG_CHANNEL_FORMULARY = 'ccg.channel.formulary';
    // Able to view all ccg channel formularies
    static CCG_CHANNEL_FORMULARY_VIEW_ANY = 'ccg.channel.formulary.view.any';
    // Able to view single ccg channel formulary
    static CCG_CHANNEL_FORMULARY_VIEW_SINGLE = 'ccg.channel.formulary.view.single';
    // Able to use all ccg channel formulary formulary classification permissions
    static CCG_CHANNEL_FORMULARY_FORMULARY_CLASSIFICATION = 'ccg.channel.formulary.formulary_classification';
    // Able to view all ccg channel formulary formulary classifications
    static CCG_CHANNEL_FORMULARY_FORMULARY_CLASSIFICATION_VIEW_ANY = 'ccg.channel.formulary.formulary_classification.view.any';
    // Able to view single ccg channel formulary formulary classification
    static CCG_CHANNEL_FORMULARY_FORMULARY_CLASSIFICATION_VIEW_SINGLE = 'ccg.channel.formulary.formulary_classification.view.single';
    // Able to use all ccg channel location permissions
    static CCG_CHANNEL_LOCATION = 'ccg.channel.location';
    // Able to view all ccg channel locations
    static CCG_CHANNEL_LOCATION_VIEW_ANY = 'ccg.channel.location.view.any';
    // Able to view single ccg channel location
    static CCG_CHANNEL_LOCATION_VIEW_SINGLE = 'ccg.channel.location.view.single';
    // 
    static CCG_SUPPLIER = 'ccg.supplier';
    // Able to view all ccg suppliers
    static CCG_SUPPLIER_VIEW_ALL = 'ccg.supplier.view.all';
    // 
    static CCG_SUPPLIER_ATTACH = 'ccg.supplier.attach';
    // 
    static CCG_SUPPLIER_DETACH = 'ccg.supplier.detach';
    // Able to use all ccg location permissions
    static CCG_LOCATION = 'ccg.location';
    // Able to manage ccg location crud
    static CCG_LOCATION_CRUD = 'ccg.location.crud';
    // Able to view all ccg locations
    static CCG_LOCATION_VIEW_ANY = 'ccg.location.view.any';
    // Able to view single ccg location
    static CCG_LOCATION_VIEW_SINGLE = 'ccg.location.view.single';
    // Able to create ccg location
    static CCG_LOCATION_CREATE = 'ccg.location.create';
    // Able to update ccg location
    static CCG_LOCATION_UPDATE = 'ccg.location.update';
    // Able to delete ccg location
    static CCG_LOCATION_DELETE = 'ccg.location.delete';
    // Able to restore ccg location
    static CCG_LOCATION_RESTORE = 'ccg.location.restore';
    // Able to force delete ccg location
    static CCG_LOCATION_FORCE_DELETE = 'ccg.location.force_delete';
    // Able to use all ccg location formulary classification permissions
    static CCG_LOCATION_FORMULARY_CLASSIFICATION = 'ccg.location.formulary_classification';
    // Able to view all ccg location formulary classifications
    static CCG_LOCATION_FORMULARY_CLASSIFICATION_VIEW_ANY = 'ccg.location.formulary_classification.view.all';
    // Able to view single ccg location formulary classification
    static CCG_LOCATION_FORMULARY_CLASSIFICATION_VIEW_SINGLE = 'ccg.location.formulary_classification.view.single';
    // Able to attach ccg location formulary classification
    static CCG_LOCATION_FORMULARY_CLASSIFICATION_ATTACH = 'ccg.location.formulary_classification.attach';
    // Able to detach ccg location formulary classification
    static CCG_LOCATION_FORMULARY_CLASSIFICATION_DETACH = 'ccg.location.formulary_classification.detach';
    // Able to use all ccg location supply route permissions
    static CCG_LOCATION_SUPPLY_ROUTE = 'ccg.location.supply_route';
    // Able to view all ccg location supply routes
    static CCG_LOCATION_SUPPLY_ROUTE_VIEW_ANY = 'ccg.location.supply_route.view.any';
    // Able to view single ccg location supply route
    static CCG_LOCATION_SUPPLY_ROUTE_VIEW_SINGLE = 'ccg.location.supply_route.view.single';
    // Able to attach ccg location supply route
    static CCG_LOCATION_SUPPLY_ROUTE_ATTACH = 'ccg.location.supply_route.attach';
    // Able to detach ccg location supply route
    static CCG_LOCATION_SUPPLY_ROUTE_DETACH = 'ccg.location.supply_route.detach';
    // Able to use all location permissions
    static LOCATION = 'location';
    // Able to manage location crud
    static LOCATION_CRUD = 'location.crud';
    // Able to view all locations
    static LOCATION_VIEW_ANY = 'location.view.any';
    // Able to view single location
    static LOCATION_VIEW_SINGLE = 'location.view.single';
    // Able to view all implicit locations
    static LOCATION_VIEW_IMPLICIT = 'location.view.implicit';
    // Able to create location
    static LOCATION_CREATE = 'location.create';
    // Able to update location
    static LOCATION_UPDATE = 'location.update';
    // Able to delete location
    static LOCATION_DELETE = 'location.delete';
    // Able to restore location
    static LOCATION_RESTORE = 'location.restore';
    // Able to force delete location
    static LOCATION_FORCE_DELETE = 'location.force_delete';
    // Able to use all location formulary classification product override permissions
    static LOCATION_FORMULARY_CLASSIFICATION_PRODUCT_OVERRIDE = 'location.formulary_classification_product_override';
    // Able to manage location formulary classification product override crud
    static LOCATION_FORMULARY_CLASSIFICATION_PRODUCT_OVERRIDE_CRUD = 'location.formulary_classification_product_override.crud';
    // Able to view all location formulary classification product overrides
    static LOCATION_FORMULARY_CLASSIFICATION_PRODUCT_OVERRIDE_VIEW_ANY = 'location.formulary_classification_product_override.view.any';
    // Able to view single formulary classification product override
    static LOCATION_FORMULARY_CLASSIFICATION_PRODUCT_OVERRIDE_VIEW_SINGLE = 'location.formulary_classification_product_override.view.single';
    // Able to create location formulary classification product override
    static LOCATION_FORMULARY_CLASSIFICATION_PRODUCT_OVERRIDE_CREATE = 'location.formulary_classification_product_override.create';
    // Able to update location formulary classification product override
    static LOCATION_FORMULARY_CLASSIFICATION_PRODUCT_OVERRIDE_UPDATE = 'location.formulary_classification_product_override.update';
    // Able to delete location formulary classification product override
    static LOCATION_FORMULARY_CLASSIFICATION_PRODUCT_OVERRIDE_DELETE = 'location.formulary_classification_product_override.delete';
    // Able to force delete location formulary classification product override
    static LOCATION_FORMULARY_CLASSIFICATION_PRODUCT_OVERRIDE_FORCE_DELETE = 'location.formulary_classification_product_override.force_delete';
    // Able to restore location formulary classification product override
    static LOCATION_FORMULARY_CLASSIFICATION_PRODUCT_OVERRIDE_RESTORE = 'location.formulary_classification_product_override.restore';
    // Able to use all location channel permissions
    static LOCATION_CHANNEL = 'location.channel';
    // Able to view all location channels
    static LOCATION_CHANNEL_VIEW_ANY = 'location.channel.view.any';
    // Able to view single location channel
    static LOCATION_CHANNEL_VIEW_SINGLE = 'location.channel.view.single';
    // Able to attach location to channel
    static LOCATION_CHANNEL_ATTACH = 'location.channel.attach';
    // Able to detach location to channel
    static LOCATION_CHANNEL_DETACH = 'location.channel.detach';
    // Able to update location to channel pivot
    static LOCATION_CHANNEL_UPDATE = 'location.channel.update';
    // Able to use all location supply route permissions
    static LOCATION_SUPPLY_ROUTE = 'location.supply_route';
    // Able to view all location supply routes
    static LOCATION_SUPPLY_ROUTE_VIEW_ANY = 'location.supply_route.view.any';
    // Able to view single location supply route
    static LOCATION_SUPPLY_ROUTE_VIEW_SINGLE = 'location.supply_route.view.single';
    // Able to attach location to supply route
    static LOCATION_SUPPLY_ROUTE_ATTACH = 'location.supply_route.attach';
    // Able to detach location to supply route
    static LOCATION_SUPPLY_ROUTE_DETACH = 'location.supply_route.detach';
    // Able to update location to supply route pivot
    static LOCATION_SUPPLY_ROUTE_UPDATE = 'location.supply_route.update';
    // Able to use all form form field permissions
    static FORM_FORM_FIELD = 'form.form.field';
    // Able to view all form form fields
    static FORM_FORM_FIELD_VIEW_ANY = 'form.form.field.view.any';
    // Able to update all form form fields
    static FORM_FORM_FIELD_UPDATE = 'form.form.field.update';
    // Able to attach form form field
    static FORM_FORM_FIELD_ATTACH = 'form.form.field.attach';
    // Able to detach form form field
    static FORM_FORM_FIELD_DETACH = 'form.form.field.detach';
    // Able to use all form permissions
    static FORM = 'form';
    // Able manage form crud
    static FORM_CRUD = 'form.crud';
    // Able to view all forms
    static FORM_VIEW_ANY = 'form.view.any';
    // Able to view single form
    static FORM_VIEW_SINGLE = 'form.view.single';
    // Able to create form
    static FORM_CREATE = 'form.create';
    // Able to update form
    static FORM_UPDATE = 'form.update';
    // Able to delete form
    static FORM_DELETE = 'form.delete';
    // Able to use all form field permissions
    static FORM_FIELD = 'form_field';
    // Able to manage form field crud
    static FORM_FIELD_CRUD = 'form_field.crud';
    // Able to view all form fields
    static FORM_FIELD_VIEW_ANY = 'form_field.view.any';
    // Able to view single form field
    static FORM_FIELD_VIEW_SINGLE = 'form_field.view.single';
    // Able to create form field
    static FORM_FIELD_CREATE = 'form_field.create';
    // Able to update form field
    static FORM_FIELD_UPDATE = 'form_field.update';
    // Able to delete form field
    static FORM_FIELD_DELETE = 'form_field.delete';
    // Able to use all form field option permissions
    static FORM_FIELD_OPTION = 'form_field.option';
    // Able to manage form field option crud
    static FORM_FIELD_OPTION_CRUD = 'form_field.option.crud';
    // Able to view all form field options
    static FORM_FIELD_OPTION_VIEW_ANY = 'form_field.option.view.any';
    // Able to view single form field option
    static FORM_FIELD_OPTION_VIEW_SINGLE = 'form_field.option.view.single';
    // Able to create form field option
    static FORM_FIELD_OPTION_CREATE = 'form_field.option.create';
    // Able to update form field
    static FORM_FIELD_OPTION_UPDATE = 'form_field.option.update';
    // Able to delete form field
    static FORM_FIELD_OPTION_DELETE = 'form_field.option.delete';
    // Able to use all form field type permissions
    static FORM_FIELD_TYPE = 'form_field.type';
    // Able to view all form field types
    static FORM_FIELD_TYPE_VIEW_ANY = 'form_field.type.view.any';
    // Able to use all form type permissions
    static FORM_TYPE = 'form.type';
    // Able to view all form types
    static FORM_TYPE_VIEW_ANY = 'form.type.view.any';
    // Able to use all form crud permissions
    static FORM_FORM_CRUD = 'form.form_crud';
    // Able to use all attribute permissions
    static ATTRIBUTE = 'attribute';
    // Able to manage attribute crud
    static ATTRIBUTE_CRUD = 'attribute.crud';
    // Able to view all attributes
    static ATTRIBUTE_VIEW_ANY = 'attribute.view.any';
    // Able to view single attribute
    static ATTRIBUTE_VIEW_SINGLE = 'attribute.view.single';
    // Able to create attribute
    static ATTRIBUTE_CREATE = 'attribute.create';
    // Able to update attribute
    static ATTRIBUTE_UPDATE = 'attribute.update';
    // Able to delete attribute
    static ATTRIBUTE_DELETE = 'attribute.delete';
    // Able to use all attribute family permissions
    static ATTRIBUTE_FAMILY = 'attribute_family';
    // Able to manage attribute family crud
    static ATTRIBUTE_FAMILY_CRUD = 'attribute_family.crud';
    // Able to view all attribute families
    static ATTRIBUTE_FAMILY_VIEW_ANY = 'attribute_family.view.any';
    // Able to view single attribute family
    static ATTRIBUTE_FAMILY_VIEW_SINGLE = 'attribute_family.view.single';
    // Able to create attribute family
    static ATTRIBUTE_FAMILY_CREATE = 'attribute_family.create';
    // Able to update attribute family
    static ATTRIBUTE_FAMILY_UPDATE = 'attribute_family.update';
    // Able to delete attribute family
    static ATTRIBUTE_FAMILY_DELETE = 'attribute_family.delete';
    // Able to use all attribute family taxonomy permissions
    static ATTRIBUTE_FAMILY_TAXONOMY = 'attribute_family.taxonomy';
    // Able to view all attribute family taxonomies
    static ATTRIBUTE_FAMILY_TAXONOMY_VIEW_ANY = 'attribute_family.taxonomy.view.any';
    // Able to use all attribute family attribute permissions
    static ATTRIBUTE_FAMILY_ATTRIBUTE = 'attribute_family.attribute';
    // Able to view all attribute family attributes
    static ATTRIBUTE_FAMILY_ATTRIBUTE_VIEW_ANY = 'attribute_family.attribute.view.any';
    // Able to attach attribute family attribute
    static ATTRIBUTE_FAMILY_ATTRIBUTE_ATTACH = 'attribute_family.attribute.attach';
    // Able to detach attribute family attribute
    static ATTRIBUTE_FAMILY_ATTRIBUTE_DETACH = 'attribute_family.attribute.detach';
    // Able to use all formulary product permissions
    static FORMULARY_PRODUCT = 'formulary_product';
    // Able to manage formulary product crud
    static FORMULARY_PRODUCT_CRUD = 'formulary_product.crud';
    // Able to view all formulary products
    static FORMULARY_PRODUCT_VIEW_ANY = 'formulary_product.view.any';
    // Able to view single formulary product
    static FORMULARY_PRODUCT_VIEW_SINGLE = 'formulary_product.view.single';
    // Able to create formulary product
    static FORMULARY_PRODUCT_CREATE = 'formulary_product.create';
    // Able to update formulary product
    static FORMULARY_PRODUCT_UPDATE = 'formulary_product.update';
    // Able to delete formulary product
    static FORMULARY_PRODUCT_DELETE = 'formulary_product.delete';
    // Able to use all formulary classification product override permissions
    static FORMULARY_CLASSIFICATION_PRODUCT_OVERRIDE = 'formulary_classification_product_override';
    // Able to manage formulary classification product override crud
    static FORMULARY_CLASSIFICATION_PRODUCT_OVERRIDE_CRUD = 'formulary_classification_product_override.crud';
    // Able to view all formulary classification product overrides
    static FORMULARY_CLASSIFICATION_PRODUCT_OVERRIDE_VIEW_ANY = 'formulary_classification_product_override.view.any';
    // Able to view single formulary classification product override
    static FORMULARY_CLASSIFICATION_PRODUCT_OVERRIDE_VIEW_SINGLE = 'formulary_classification_product_override.view.single';
    // Able to create formulary classification product override
    static FORMULARY_CLASSIFICATION_PRODUCT_OVERRIDE_CREATE = 'formulary_classification_product_override.create';
    // Able to update formulary classification product override
    static FORMULARY_CLASSIFICATION_PRODUCT_OVERRIDE_UPDATE = 'formulary_classification_product_override.update';
    // Able to delete formulary classification product override
    static FORMULARY_CLASSIFICATION_PRODUCT_OVERRIDE_DELETE = 'formulary_classification_product_override.delete';
    // Able to fully manage formulary classification products
    static FORMULARY_CLASSIFICATION_PRODUCT = 'formulary_classification_product';
    // Able to manage formulary classification product crud
    static FORMULARY_CLASSIFICATION_PRODUCT_CRUD = 'formulary_classification_product.crud';
    // Able to view all formulary classification products
    static FORMULARY_CLASSIFICATION_PRODUCT_VIEW_ANY = 'formulary_classification_product.view.any';
    // Able to view a single formulary classification product
    static FORMULARY_CLASSIFICATION_PRODUCT_VIEW_SINGLE = 'formulary_classification_product.view.single';
    // Able to create formulary classification products
    static FORMULARY_CLASSIFICATION_PRODUCT_CREATE = 'formulary_classification_product.create';
    // Able to update a formulary classification product
    static FORMULARY_CLASSIFICATION_PRODUCT_UPDATE = 'formulary_classification_product.update';
    // Able to delete a formulary classification product
    static FORMULARY_CLASSIFICATION_PRODUCT_DELETE = 'formulary_classification_product.delete';
    // Able to fully manage formulary classifications
    static FORMULARY_CLASSIFICATION = 'formulary_classification';
    // Able to manage formulary classification crud
    static FORMULARY_CLASSIFICATION_CRUD = 'formulary_classification.crud';
    // Able to view all formulary classifications
    static FORMULARY_CLASSIFICATION_VIEW_ANY = 'formulary_classification.view.any';
    // Able to view a single formulary classification
    static FORMULARY_CLASSIFICATION_VIEW_SINGLE = 'formulary_classification.view.single';
    // Able to create formulary classification
    static FORMULARY_CLASSIFICATION_CREATE = 'formulary_classification.create';
    // Able to update a formulary classification
    static FORMULARY_CLASSIFICATION_UPDATE = 'formulary_classification.update';
    // Able to delete a formulary classification
    static FORMULARY_CLASSIFICATION_DELETE = 'formulary_classification.delete';
    // Able to use all formulary classification product permissions
    static FORMULARY_CLASSIFICATION_FORMULARY_CLASSIFICATION_PRODUCT = 'formulary_classification.formulary_classification_product';
    // Able to manage formulary classification product crud
    static FORMULARY_CLASSIFICATION_FORMULARY_CLASSIFICATION_PRODUCT_CRUD = 'formulary_classification.formulary_classification_product.crud';
    // Able to view all formulary classification products
    static FORMULARY_CLASSIFICATION_FORMULARY_CLASSIFICATION_PRODUCT_VIEW_ANY = 'formulary_classification.formulary_classification_product.view.any';
    // Able to view single formulary classification product
    static FORMULARY_CLASSIFICATION_FORMULARY_CLASSIFICATION_PRODUCT_VIEW_SINGLE = 'formulary_classification.formulary_classification_product.view.single';
    // Able to create formulary classification product
    static FORMULARY_CLASSIFICATION_FORMULARY_CLASSIFICATION_PRODUCT_CREATE = 'formulary_classification.formulary_classification_product.create';
    // Able to update formulary classification product
    static FORMULARY_CLASSIFICATION_FORMULARY_CLASSIFICATION_PRODUCT_UPDATE = 'formulary_classification.formulary_classification_product.update';
    // Able to delete formulary classification product
    static FORMULARY_CLASSIFICATION_FORMULARY_CLASSIFICATION_PRODUCT_DELETE = 'formulary_classification.formulary_classification_product.delete';
    // Able to use all formulary permissions
    static FORMULARY = 'formulary';
    // Able to manage formulary crud
    static FORMULARY_CRUD = 'formulary.crud';
    // Able to view all formularies
    static FORMULARY_VIEW_ANY = 'formulary.view.any';
    // Able to view single formulary
    static FORMULARY_VIEW_SINGLE = 'formulary.view.single';
    // Able to create formulary
    static FORMULARY_CREATE = 'formulary.create';
    // Able to update formulary
    static FORMULARY_UPDATE = 'formulary.update';
    // Able to delete formulary
    static FORMULARY_DELETE = 'formulary.delete';
    // Able to use all formulary formulary product permissions
    static FORMULARY_FORMULARY_PRODUCT = 'formulary.formulary_product';
    // Able to manage formulary formulary product crud
    static FORMULARY_FORMULARY_PRODUCT_CRUD = 'formulary.formulary_product.crud';
    // Able to view all formulary formulary products
    static FORMULARY_FORMULARY_PRODUCT_VIEW_ANY = 'formulary.formulary_product.view.any';
    // Able to view single formulary formulary product
    static FORMULARY_FORMULARY_PRODUCT_VIEW_SINGLE = 'formulary.formulary_product.view.single';
    // Able to create formulary formulary product
    static FORMULARY_FORMULARY_PRODUCT_CREATE = 'formulary.formulary_product.create';
    // Able to update formulary formulary product
    static FORMULARY_FORMULARY_PRODUCT_UPDATE = 'formulary.formulary_product.update';
    // Able to delete formulary formulary product
    static FORMULARY_FORMULARY_PRODUCT_DELETE = 'formulary.formulary_product.delete';
    // Able to use all formulary formulary classification permissions
    static FORMULARY_FORMULARY_CLASSIFICATION = 'formulary.formulary_classification';
    // Able to manage formulary formulary classification crud
    static FORMULARY_FORMULARY_CLASSIFICATION_CRUD = 'formulary.formulary_classification.crud';
    // Able to view all formulary formulary classifications
    static FORMULARY_FORMULARY_CLASSIFICATION_VIEW_ANY = 'formulary.formulary_classification.view.any';
    // Able to view single formulary formulary classification
    static FORMULARY_FORMULARY_CLASSIFICATION_VIEW_SINGLE = 'formulary.formulary_classification.view.single';
    // Able to create formulary formulary classification
    static FORMULARY_FORMULARY_CLASSIFICATION_CREATE = 'formulary.formulary_classification.create';
    // Able to update formulary formulary classification
    static FORMULARY_FORMULARY_CLASSIFICATION_UPDATE = 'formulary.formulary_classification.update';
    // Able to delete formulary formulary classification
    static FORMULARY_FORMULARY_CLASSIFICATION_DELETE = 'formulary.formulary_classification.delete';
    // Able to fully manage Carts
    static CART_BYPASS = 'cart.bypass';
    // Able to view all Carts
    static CART_VIEW_ALL = 'cart.view.all';
    // Able to view a single Cart
    static CART_VIEW_SINGLE = 'cart.view.single';
    // Able to update a single Cart
    static CART_UPDATE = 'cart.update';
    // Able to create a Cart
    static CART_CREATE = 'cart.create';
    // Able to delete a Cart
    static CART_DELETE = 'cart.delete';
    // Able to force delete a Cart
    static CART_FORCE_DELETE = 'cart.force_delete';
    // Able to restore a Cart
    static CART_RESTORE = 'cart.restore';
    // Able to create a active cart
    static CART_CREATE_ACTIVE = 'cart.create.active';
    // Able to view there active cart
    static CART_VIEW_ACTIVE = 'cart.view.active';
    // Able to delete there active cart
    static CART_DELETE_ACTIVE = 'cart.delete.active';
    // Able to force delete there active cart
    static CART_FORCE_DELETE_ACTIVE = 'cart.form_delete.active';
    // Able to fully manage Taxonomies
    static TAXONOMY = 'taxonomy';
    // Able to manage taxonomy crud
    static TAXONOMY_CRUD = 'taxonomy.crud';
    // Able to view all Taxonomies
    static TAXONOMY_VIEW_ANY = 'taxonomy.view.any';
    // Able to view a single Taxonomy
    static TAXONOMY_VIEW_SINGLE = 'taxonomy.view.single';
    // Able to update a Taxonomy
    static TAXONOMY_UPDATE = 'taxonomy.update';
    // Able to create a Taxonomy
    static TAXONOMY_CREATE = 'taxonomy.create';
    // Able to delete a Taxonomy
    static TAXONOMY_DELETE = 'taxonomy.delete';
    // Able to force delete a Taxonomy
    static TAXONOMY_FORCE_DELETE = 'taxonomy.force_delete';
    // Able to restore a deleted Taxonomy
    static TAXONOMY_RESTORE = 'taxonomy.restore';
    // Able to fully manage terms
    static TERM = 'term';
    // Able to manage term crud
    static TERM_CRUD = 'term.crud';
    // Able to view all terms
    static TERM_VIEW_ANY = 'term.view.any';
    // Able to view a single term
    static TERM_VIEW_SINGLE = 'term.view.single';
    // Able to update a term
    static TERM_UPDATE = 'term.update';
    // Able to create a term
    static TERM_CREATE = 'term.create';
    // Able to delete a term
    static TERM_DELETE = 'term.delete';
    // Able to force delete a term
    static TERM_FORCE_DELETE = 'term.force_delete';
    // Able to restore a deleted term
    static TERM_RESTORE = 'term.restore';
    // Able to fully manage Supply Routes
    static SUPPLY_ROUTE_BYPASS = 'supply_route.bypass';
    // Able to view all Supply Routes
    static SUPPLY_ROUTE_VIEW_ALL = 'supply_route.view.all';
    // Able to view a single Supply Route
    static SUPPLY_ROUTE_VIEW_SINGLE = 'supply_route.view.single';
    // Able to create a Supply Route
    static SUPPLY_ROUTE_CREATE = 'supply_route.create';
    // Able to update a Supply Route
    static SUPPLY_ROUTE_UPDATE = 'supply_route.update';
    // Able to delete a Supply Route
    static SUPPLY_ROUTE_DELETE = 'supply_route.delete';
    // Able to force delete a supply Route
    static SUPPLY_ROUTE_FORCE_DELETE = 'supply_route.force_delete';
    // Able to restore a supply route
    static SUPPLY_ROUTE_RESTORE = 'supply_route.restore';
    // Able to use channel ccg
    static CHANNEL_CCG = 'channel.ccg';
    // Able to manage crud for channel ccg
    static CHANNEL_CCG_CRUD = 'channel.ccg.crud';
    // Able to view all ccg assigned to channel
    static CHANNEL_CCG_VIEW_ANY = 'channel.ccg.view.any';
    // Able to view all ccg assigned to user assigned channel
    static CHANNEL_CCG_ASSIGNED_VIEW_ANY = 'channel.ccg.assigned.view.any';
    // Able to view single ccg assigned to channel
    static CHANNEL_CCG_VIEW_SINGLE = 'channel.ccg.view.single';
    // Able to view single ccg assigned to user assigned channel
    static CHANNEL_CCG_ASSIGNED_VIEW_SINGLE = 'channel.ccg.assigned.view.single';
    // Able to attach ccg to channel
    static CHANNEL_CCG_ATTACH = 'channel.ccg.attach';
    // Able to attach ccg to assigned user channel
    static CHANNEL_CCG_ASSIGNED_ATTACH = 'channel.ccg.assigned.attach';
    // Able to detach ccg from channel
    static CHANNEL_CCG_DETACH = 'channel.ccg.detach';
    // Able to detach ccg from user assigned channel
    static CHANNEL_CCG_ASSIGNED_DETACH = 'channel.ccg.assigned.detach';
    // Able to update ccg from channel
    static CHANNEL_CCG_UPDATE = 'channel.ccg.update';
    // Able to update ccg from user assigned channel
    static CHANNEL_CCG_ASSIGNED_UPDATE = 'channel.ccg.assigned.update';
    // Able to attach ccg formulary to channel
    static CHANNEL_CCG_FORMULARY_ATTACH = 'channel.ccg.formulary.attach';
    // Able to attach ccg formulary to assigned user channel
    static CHANNEL_CCG_FORMULARY_ASSIGNED_ATTACH = 'channel.ccg.formulary.assigned.attach';
    // Able to detach ccg formulary from channel
    static CHANNEL_CCG_FORMULARY_DETACH = 'channel.ccg.formulary.detach';
    // Able to detach ccg formulary from user assigned channel
    static CHANNEL_CCG_FORMULARY_ASSIGNED_DETACH = 'channel.ccg.formulary.assigned.detach';
    // Able to update ccg formulary from user assigned channel
    static CHANNEL_CCG_FORMULARY_ASSIGNED_UPDATE = 'channel.ccg.formulary.assigned.update';
    // Able use view channel ccg locations
    static CHANNEL_CCG_LOCATION = 'channel.ccg.location';
    // Able to manage channel ccg location crud
    static CHANNEL_CCG_LOCATION_CRUD = 'channel.ccg.location.crud';
    // Able to view all channel ccg location
    static CHANNEL_CCG_LOCATION_VIEW_ANY = 'channel.ccg.location.view.any';
    // Able to view all channel assigned to user ccg location
    static CHANNEL_CCG_LOCATION_ASSIGNED_VIEW_ANY = 'channel.ccg.location.assigned.view.any';
    // Able to view single channel ccg location
    static CHANNEL_CCG_LOCATION_VIEW_SINGLE = 'channel.ccg.location.view.single';
    // Able to view single channel assigned to user ccg location
    static CHANNEL_CCG_LOCATION_ASSIGNED_VIEW_SINGLE = 'channel.ccg.location.assigned.view.single';
    // Able to bulk attach locations to channel
    static CHANNEL_CCG_LOCATION_BULK_ATTACH = 'channel.ccg.location.bulk.attach';
    // Able to bulk attach locations to assigned user channel
    static CHANNEL_CCG_LOCATION_ASSIGNED_BULK_ATTACH = 'channel.ccg.location.assigned.bulk.attach';
    // Able to use channel location
    static CHANNEL_LOCATION = 'channel.location';
    // Able to manage channel location crud
    static CHANNEL_LOCATION_CRUD = 'channel.location.crud';
    // Able to view all locations assigned to channel
    static CHANNEL_LOCATION_VIEW_ANY = 'channel.location.view.any';
    // Able to view all locations assigned to channel assigned to user
    static CHANNEL_LOCATION_ASSIGNED_VIEW_ANY = 'channel.location.assigned.view.any';
    // Able to view single location assigned to channel
    static CHANNEL_LOCATION_VIEW_SINGLE = 'channel.location.view.single';
    // Able to view single location assigned to channel assigned to user
    static CHANNEL_LOCATION_ASSIGNED_VIEW_SINGLE = 'channel.location.assigned.view.single';
    // Able to attach locations to channels
    static CHANNEL_LOCATION_ATTACH = 'channel.location.attach';
    // Able to attach locations to channels to assigned user
    static CHANNEL_LOCATION_ASSIGNED_ATTACH = 'channel.location.assigned.attach';
    // Able to detach locations to channels
    static CHANNEL_LOCATION_DETACH = 'channel.location.detach';
    // Able to detach locations to channels to assigned user
    static CHANNEL_LOCATION_ASSIGNED_DETACH = 'channel.location.assigned.detach';
    // Able to update locations from channels
    static CHANNEL_LOCATION_UPDATE = 'channel.location.update';
    // Able to update locations from channels assigned to user
    static CHANNEL_LOCATION_ASSIGNED_UPDATE = 'channel.location.assigned.update';
    // Able to bulk attach locations to channel
    static CHANNEL_LOCATION_BULK_ATTACH = 'channel.location.bulk.attach';
    // Able to bulk attach locations to channel assigned to user
    static CHANNEL_LOCATION_ASSIGNED_BULK_ATTACH = 'channel.location.assigned.bulk.attach';
    // Able to view channel ccg locations
    static CHANNEL_CCG_LOCATIONS = 'channel.ccg.locations';
    // Able to use product attribute value permissions
    static PRODUCT_ATTRIBUTE_VALUE = 'product.attribute.value';
    // Able to view all product attribute values
    static PRODUCT_ATTRIBUTE_VALUE_VIEW_ANY = 'product.attribute.value.view.any';
    // Able to fully manage product stock
    static PRODUCT_STOCK = 'product.stock';
    // Able to manage product stock crud
    static PRODUCT_STOCK_CRUD = 'product.stock.crud';
    // Able to view all product stock
    static PRODUCT_STOCK_VIEW_ANY = 'product.stock.view.any';
    // Able to view a single product stock
    static PRODUCT_STOCK_VIEW_SINGLE = 'product.stock.view.single';
    // Able to update a product stock
    static PRODUCT_STOCK_UPDATE = 'product.stock.update';
    // Able to create product stock
    static PRODUCT_STOCK_CREATE = 'product.stock.create';
    // Able to delete a product stock
    static PRODUCT_STOCK_DELETE = 'product.stock.delete';
    // Able to force delete a product stock
    static PRODUCT_STOCK_FORCE_DELETE = 'product.stock.force_delete';
    // Able to restore a delete product stock
    static PRODUCT_STOCK_RESTORE = 'product.stock.restore';
    // Able to fully manage product barcode submissions
    static PRODUCT_BARCODE_SUBMISSION = 'product.barcode.submission';
    // Able to manage product barcode submissions crud
    static PRODUCT_BARCODE_SUBMISSION_CRUD = 'product.barcode.submission.crud';
    // Able to view all product barcode submissions
    static PRODUCT_BARCODE_SUBMISSION_VIEW_ANY = 'product.barcode.submission.view.any';
    // Able to view a single product barcode submission
    static PRODUCT_BARCODE_SUBMISSION_VIEW_SINGLE = 'product.barcode.submission.view.single';
    // Able to update a product barcode submission
    static PRODUCT_BARCODE_SUBMISSION_UPDATE = 'product.barcode.submission.update';
    // Able to create product barcode submission
    static PRODUCT_BARCODE_SUBMISSION_CREATE = 'product.barcode.submission.create';
    // Able to delete a product barcode submission
    static PRODUCT_BARCODE_SUBMISSION_DELETE = 'product.barcode.submission.delete';
    // Able to force delete a product barcode submission
    static PRODUCT_BARCODE_SUBMISSION_FORCE_DELETE = 'product.barcode.submission.force_delete';
    // Able to restore a delete product barcode submission
    static PRODUCT_BARCODE_SUBMISSION_RESTORE = 'product.barcode.submission.restore';
    // Able to fully manage product types
    static PRODUCT_PRODUCT_TYPE = 'product.type';
    // Full system admin override, bypasses any all permissions;
    static SYSTEM_ADMIN_OVERRIDE = 'system.admin.override';
    // Able to fully manage permissions
    static PERMISSION_BYPASS = 'permission.bypass';
    // Able to view all permissions
    static PERMISSION_VIEW_ALL = 'permission.view.all';
    // Able to manage users permissions
    static PERMISSION_USER_MANAGE = 'permission.user.manage';
    // Able to manage roles permissions
    static PERMISSION_ROLE_MANAGE = 'permission.role.manage';
    // Able to fully manage roles
    static ROLE_BYPASS = 'role.bypass';
    // Able to view all roles
    static ROLE_VIEW_ALL = 'role.view.all';
    // Able to view a single role
    static ROLE_VIEW_SINGLE = 'role.view.single';
    // Able to update a role
    static ROLE_UPDATE = 'role.update';
    // Able to create a role
    static ROLE_CREATE = 'role.create';
    // Able to delete a role
    static ROLE_DELETE = 'role.delete';
    // Able to force delete a role
    static ROLE_FORCE_DELETE = 'role.force_delete';
    // Able to restore a deleted role
    static ROLE_RESTORE = 'role.restore';
    // Able to fully manage categories
    static CATEGORY_BYPASS = 'category.bypass';
    // Able to view all categories
    static CATEGORY_VIEW_ALL = 'category.view.all';
    // Able to view a single category
    static CATEGORY_VIEW_SINGLE = 'category.view.single';
    // Able to update a category
    static CATEGORY_UPDATE = 'category.update';
    // Able to create categories
    static CATEGORY_CREATE = 'category.create';
    // Able to delete a category
    static CATEGORY_DELETE = 'category.delete';
    // Able to force delete a category
    static CATEGORY_FORCE_DELETE = 'category.force_delete';
    // Able to restore a delete category
    static CATEGORY_RESTORE = 'category.restore';
    // Able to fully manage nhs patients
    static NHS_PATIENT = 'nhs_patient';
    // Able to manage nhs patient crud
    static NHS_PATIENT_CRUD = 'nhs_patient.crud';
    // Able to view all nhs patients
    static NHS_PATIENT_VIEW_ANY = 'nhs_patient.view.any';
    // Able to view a single nhs patient
    static NHS_PATIENT_VIEW_SINGLE = 'nhs_patient.view.single';
    // Able to update a nhs patient
    static NHS_PATIENT_UPDATE = 'nhs_patient.update';
    // Able to create nhs patient
    static NHS_PATIENT_CREATE = 'nhs_patient.create';
    // Able to delete a nhs patient
    static NHS_PATIENT_DELETE = 'nhs_patient.delete';
    // Able to force delete a nhs patient
    static NHS_PATIENT_FORCE_DELETE = 'nhs_patient.force_delete';
    // Able to restore a delete nhs patient
    static NHS_PATIENT_RESTORE = 'nhs_patient.restore';
    // Able to fully manage ccgs
    static CCG = 'ccg';
    // Able to manage ccg crud
    static CCG_CRUD = 'ccg.crud';
    // Able to view all ccgs
    static CCG_VIEW_ANY = 'ccg.view.any';
    // Able to view a single ccg
    static CCG_VIEW_SINGLE = 'ccg.view.single';
    // Able to update a ccg
    static CCG_UPDATE = 'ccg.update';
    // Able to create ccg
    static CCG_CREATE = 'ccg.create';
    // Able to delete a ccg
    static CCG_DELETE = 'ccg.delete';
    // Able to force delete a ccg
    static CCG_FORCE_DELETE = 'ccg.force_delete';
    // Able to restore a delete ccg
    static CCG_RESTORE = 'ccg.restore';
    // Able to view a implicit ccgs
    static CCG_VIEW_IMPLICIT = 'ccg.view.implicit';
    // Able to fully manage resources
    static RESOURCE = 'resource';
    // Able to manage resource crud
    static RESOURCE_CRUD = 'resource.crud';
    // Able to view all resources
    static RESOURCE_VIEW_ANY = 'resource.view.any';
    // Able to view a single resource
    static RESOURCE_VIEW_SINGLE = 'resource.view.single';
    // Able to update a resource
    static RESOURCE_UPDATE = 'resource.update';
    // Able to create resource
    static RESOURCE_CREATE = 'resource.create';
    // Able to delete a resource
    static RESOURCE_DELETE = 'resource.delete';
    // Able to force delete a resource
    static RESOURCE_FORCE_DELETE = 'resource.force_delete';
    // Able to restore a delete resource
    static RESOURCE_RESTORE = 'resource.restore';
    // Able to fully manage resource routes
    static RESOURCE_ROUTE = 'resource_route';
    // Able to manage resource route crud
    static RESOURCE_ROUTE_CRUD = 'resource_route.crud';
    // Able to view all resource routes
    static RESOURCE_ROUTE_VIEW_ANY = 'resource_route.view.any';
    // Able to view a single resource route
    static RESOURCE_ROUTE_VIEW_SINGLE = 'resource_route.view.single';
    // Able to update a resource route
    static RESOURCE_ROUTE_UPDATE = 'resource_route.update';
    // Able to create resource route
    static RESOURCE_ROUTE_CREATE = 'resource_route.create';
    // Able to delete a resource route
    static RESOURCE_ROUTE_DELETE = 'resource_route.delete';
    // Able to force delete a resource route
    static RESOURCE_ROUTE_FORCE_DELETE = 'resource_route.force_delete';
    // Able to restore a delete resource route
    static RESOURCE_ROUTE_RESTORE = 'resource_route.restore';
    // Able to fully manage resource gui tables
    static RESOURCE_GUI_TABLE = 'resource_gui_table';
    // Able to manage resource gui table crud
    static RESOURCE_GUI_TABLE_CRUD = 'resource_gui_table.crud';
    // Able to view all resource gui tables
    static RESOURCE_GUI_TABLE_VIEW_ANY = 'resource_gui_table.view.any';
    // Able to view a single resource gui table
    static RESOURCE_GUI_TABLE_VIEW_SINGLE = 'resource_gui_table.view.single';
    // Able to update a resource gui table
    static RESOURCE_GUI_TABLE_UPDATE = 'resource_gui_table.update';
    // Able to create resource gui table
    static RESOURCE_GUI_TABLE_CREATE = 'resource_gui_table.create';
    // Able to delete a resource gui table
    static RESOURCE_GUI_TABLE_DELETE = 'resource_gui_table.delete';
    // Able to force delete a resource gui table
    static RESOURCE_GUI_TABLE_FORCE_DELETE = 'resource_gui_table.force_delete';
    // Able to restore a delete resource gui table
    static RESOURCE_GUI_TABLE_RESTORE = 'resource_gui_table.restore';
    // Able to fully manage resource gui table columns
    static RESOURCE_GUI_TABLE_COLUMN = 'resource_gui_table_column';
    // Able to manage resource gui table column crud
    static RESOURCE_GUI_TABLE_COLUMN_CRUD = 'resource_gui_table_column.crud';
    // Able to view all resource gui table columns
    static RESOURCE_GUI_TABLE_COLUMN_VIEW_ANY = 'resource_gui_table_column.view.any';
    // Able to view a single resource gui table column
    static RESOURCE_GUI_TABLE_COLUMN_VIEW_SINGLE = 'resource_gui_table_column.view.single';
    // Able to update a resource gui table column
    static RESOURCE_GUI_TABLE_COLUMN_UPDATE = 'resource_gui_table_column.update';
    // Able to create resource gui table column
    static RESOURCE_GUI_TABLE_COLUMN_CREATE = 'resource_gui_table_column.create';
    // Able to delete a resource gui table column
    static RESOURCE_GUI_TABLE_COLUMN_DELETE = 'resource_gui_table_column.delete';
    // Able to force delete a resource gui table column
    static RESOURCE_GUI_TABLE_COLUMN_FORCE_DELETE = 'resource_gui_table_column.force_delete';
    // Able to restore a delete resource gui table column
    static RESOURCE_GUI_TABLE_COLUMN_RESTORE = 'resource_gui_table_column.restore';
    // Able to fully manage resource filters
    static RESOURCE_FILTER = 'resource_filter';
    // Able to manage resource filter crud
    static RESOURCE_FILTER_CRUD = 'resource_filter.crud';
    // Able to view all resource filters
    static RESOURCE_FILTER_VIEW_ANY = 'resource_filter.view.any';
    // Able to view a single resource filter
    static RESOURCE_FILTER_VIEW_SINGLE = 'resource_filter.view.single';
    // Able to update a resource filter
    static RESOURCE_FILTER_UPDATE = 'resource_filter.update';
    // Able to create resource filter
    static RESOURCE_FILTER_CREATE = 'resource_filter.create';
    // Able to delete a resource filter
    static RESOURCE_FILTER_DELETE = 'resource_filter.delete';
    // Able to force delete a resource filter
    static RESOURCE_FILTER_FORCE_DELETE = 'resource_filter.force_delete';
    // Able to restore a delete resource filter
    static RESOURCE_FILTER_RESTORE = 'resource_filter.restore';
    // Able to fully manage resource filter options
    static RESOURCE_FILTER_RESOURCE_FILTER_OPTION = 'resource_filter.resource_filter_option';
    // Able to manage resource filter option crud
    static RESOURCE_FILTER_RESOURCE_FILTER_OPTION_CRUD = 'resource_filter.resource_filter_option.crud';
    // Able to view all resource filter options
    static RESOURCE_FILTER_RESOURCE_FILTER_OPTION_VIEW_ANY = 'resource_filter.resource_filter_option.view.any';
    // Able to view a single resource filter option
    static RESOURCE_FILTER_RESOURCE_FILTER_OPTION_VIEW_SINGLE = 'resource_filter.resource_filter_option.view.single';
    // Able to update a resource filter option
    static RESOURCE_FILTER_RESOURCE_FILTER_OPTION_UPDATE = 'resource_filter.resource_filter_option.update';
    // Able to create resource filter option
    static RESOURCE_FILTER_RESOURCE_FILTER_OPTION_CREATE = 'resource_filter.resource_filter_option.create';
    // Able to delete a resource filter option
    static RESOURCE_FILTER_RESOURCE_FILTER_OPTION_DELETE = 'resource_filter.resource_filter_option.delete';
    // Able to force delete a resource filter option
    static RESOURCE_FILTER_RESOURCE_FILTER_OPTION_FORCE_DELETE = 'resource_filter.resource_filter_option.force_delete';
    // Able to restore a delete resource filter option
    static RESOURCE_FILTER_RESOURCE_FILTER_OPTION_RESTORE = 'resource_filter.resource_filter_option.restore';
    // Able to fully manage resource actions
    static RESOURCE_ACTION = 'resource_action';
    // Able to manage resource action crud
    static RESOURCE_ACTION_CRUD = 'resource_action.crud';
    // Able to view all resource actions
    static RESOURCE_ACTION_VIEW_ANY = 'resource_action.view.any';
    // Able to view a single resource action
    static RESOURCE_ACTION_VIEW_SINGLE = 'resource_action.view.single';
    // Able to update a resource action
    static RESOURCE_ACTION_UPDATE = 'resource_action.update';
    // Able to create resource action
    static RESOURCE_ACTION_CREATE = 'resource_action.create';
    // Able to delete a resource action
    static RESOURCE_ACTION_DELETE = 'resource_action.delete';
    // Able to force delete a resource action
    static RESOURCE_ACTION_FORCE_DELETE = 'resource_action.force_delete';
    // Able to restore a delete resource action
    static RESOURCE_ACTION_RESTORE = 'resource_action.restore';
    // Able to force delete a formulary classification
    static FORMULARY_CLASSIFICATION_FORCE_DELETE = 'formulary_classification.force_delete';
    // Able to restore a delete formulary classification
    static FORMULARY_CLASSIFICATION_RESTORE = 'formulary_classification.restore';
    // Able to force delete a formulary classification product
    static FORMULARY_CLASSIFICATION_PRODUCT_FORCE_DELETE = 'formulary_classification_product.force_delete';
    // Able to restore a delete formulary classification products
    static FORMULARY_CLASSIFICATION_PRODUCT_RESTORE = 'formulary_classification_product.restore';
    // Able to fully manage locations
    static LOCATION_BYPASS = 'location.bypass';
    // Able to view all locations
    static LOCATION_VIEW_ALL = 'location.view.all';
    // Able to fully manage ccg suppliers
    static CCG_SUPPLIER_BYPASS = 'ccg_supplier.bypass';
    // Able to create a ccg supplier
    static CCG_SUPPLIER_CREATE = 'ccg_supplier.create';
    // Able to delete a ccg supplier
    static CCG_SUPPLIER_DELETE = 'ccg_supplier.delete';
    // Able to force delete a ccg supplier
    static CCG_SUPPLIER_FORCE_DELETE = 'ccg_supplier.force_delete';
    // Able to restore a ccg supplier
    static CCG_SUPPLIER_RESTORE = 'ccg_supplier.restore';
    // Able to fully manage suppliers
    static SUPPLIER_BYPASS = 'supplier.bypass';
    // Able to view all suppliers
    static SUPPLIER_VIEW_ALL = 'supplier.view.all';
    // 
    static SUPPLIER_VIEW_ANY = 'supplier.view.any';
    // Able to view a single supplier
    static SUPPLIER_VIEW_SINGLE = 'supplier.view.single';
    // Able to create a supplier
    static SUPPLIER_CREATE = 'supplier.create';
    // Able to update a single supplier
    static SUPPLIER_UPDATE = 'supplier.update';
    // Able to delete a supplier
    static SUPPLIER_DELETE = 'supplier.delete';
    // Able to force delete a supplier
    static SUPPLIER_FORCE_DELETE = 'supplier.force_delete';
    // Able to restore deleted suppliers
    static SUPPLIER_RESTORE = 'supplier.restore';
    // 
    static SUPPLIER_VIEW_ANY_ASSIGNED = 'supplier.view.any.assigned';
    // supplier.view.single.assigned
    static SUPPLIER_VIEW_SINGLE_ASSIGNED = 'supplier.view.single.assigned';
    // Able to fully manage supplier suborders
    static SUPPLIER_SUBORDER = 'supplier_suborder';
    // Able to view all suppliers suborders
    static SUPPLIER_SUBORDER_VIEW_ALL = 'supplier_suborder.view.all';
    // Able to fully manage supplier invoicing
    static SUPPLIER_INVOICING = 'supplier_invoicing';
    // Able to view all suppliers invoicing
    static SUPPLIER_INVOICING_VIEW_ALL = 'supplier_invoicing.view.all';
    // Able to fully manage sent supplier suborders
    static SUPPLIER_SENT_SUBORDER = 'supplier_sent_suborder';
    // Able to view all sent suppliers suborders
    static SUPPLIER_SENT_SUBORDER_VIEW_ALL = 'supplier_sent_suborder.view.all';
    // Able to fully manage finance live suborders
    static FINANCE_LIVE_SUBORDER = 'finance_live_suborder';
    // Able to view all finance live suborders
    static FINANCE_LIVE_SUBORDER_VIEW_ALL = 'finance_live_suborder.view.all';
    // Able to fully manage finance invoicing
    static FINANCE_INVOICING = 'finance_invoicing';
    // Able to view all finance invoicing
    static FINANCE_INVOICING_VIEW_ALL = 'finance_invoicing.view.all';
    // Able to fully manage NHS supply chain depots
    static NHS_SUPPLY_CHAIN_DEPOT_BYPASS = 'nhs_supply_chain_depot.bypass';
    // Able to view all NHS supply chain depots
    static NHS_SUPPLY_CHAIN_DEPOT_VIEW_ALL = 'nhs_supply_chain_depot.view.all';
    // Able to view a single NHS supply chain depot
    static NHS_SUPPLY_CHAIN_DEPOT_VIEW_SINGLE = 'nhs_supply_chain_depot.view.single';
    // Able to create a NHS supply chain depot
    static NHS_SUPPLY_CHAIN_DEPOT_CREATE = 'nhs_supply_chain_depot.create';
    // Able to update a NHS supply chain depot
    static NHS_SUPPLY_CHAIN_DEPOT_UPDATE = 'nhs_supply_chain_depot.update';
    // Able to delete a NHS supply chain depot
    static NHS_SUPPLY_CHAIN_DEPOT_DELETE = 'nhs_supply_chain_depot.delete';
    // Able to force delete a NHS supply chain depot
    static NHS_SUPPLY_CHAIN_DEPOT_FORCE_DELETE = 'nhs_supply_chain_depot.force_delete';
    // Able to restore a deleted NHS supply chain depot
    static NHS_SUPPLY_CHAIN_DEPOT_RESTORE = 'nhs_supply_chain_depot.restore';
    // Able to fully manage ccg products
    static CCG_PRODUCT_BYPASS = 'ccg_product.bypass';
    // Able to view all ccg products
    static CCG_PRODUCT_VIEW_ALL = 'ccg_product.view.all';
    // 
    static CCG_PRODUCT_VIEW_SINGLE = 'ccg_product.view.single';
    // Able to create a ccg product
    static CCG_PRODUCT_CREATE = 'ccg_product.create';
    // Able to update a ccg product
    static CCG_PRODUCT_UPDATE = 'ccg_product.update';
    // Able to delete a ccg product
    static CCG_PRODUCT_DELETE = 'ccg_product.delete';
    // Able to force delete a ccg product
    static CCG_PRODUCT_FORCE_DELETE = 'ccg_product.force_delete';
    // Able to restore a deleted ccg product
    static CCG_PRODUCT_RESTORE = 'ccg_product.restore';
    // Able to fully manage products
    static PRODUCT_BYPASS = 'product.bypass';
    // Able to fully manage products
    static PRODUCT = 'product';
    // Able to manage product crud
    static PRODUCT_CRUD = 'product.crud';
    // Able to view all products
    static PRODUCT_VIEW_ANY = 'product.view.any';
    // Able to view a single product
    static PRODUCT_VIEW_SINGLE = 'product.view.single';
    // Able to create a product
    static PRODUCT_CREATE = 'product.create';
    // Able to update a product
    static PRODUCT_UPDATE = 'product.update';
    // Able to delete a product
    static PRODUCT_DELETE = 'product.delete';
    // Able to force delete a product
    static PRODUCT_FORCE_DELETE = 'product.force_delete';
    // Able to restore a product
    static PRODUCT_RESTORE = 'product.restore';
    // Able to fully manage product supply routes
    static PRODUCT_SUPPLY_ROUTE = 'product.supply_route';
    // Able to view all product supply routes
    static PRODUCT_SUPPLY_ROUTE_VIEW_ANY = 'product.supply_route.view.any';
    // Able to view a single product supply route
    static PRODUCT_SUPPLY_ROUTE_VIEW_SINGLE = 'product.supply_route.view.single';
    // Able to assign a single product supply route to a product
    static PRODUCT_SUPPLY_ROUTE_CREATE = 'product.supply_route.create';
    // Able to detach single product supply route to a product
    static PRODUCT_SUPPLY_ROUTE_DELETE = 'product.supply_route.delete';
    // Able to fully manage product taxonomies
    static PRODUCT_TAXONOMY = 'product.taxonomy';
    // Able to view all product taxonomies
    static PRODUCT_TAXONOMY_VIEW_ANY = 'product.taxonomy.view.any';
    // Able to view a single product taxonomy
    static PRODUCT_TAXONOMY_VIEW_SINGLE = 'product.taxonomy.view.single';
    // Able to fully manage users
    static USER_BYPASS = 'user.bypass';
    // Able to view all users
    static USER_VIEW_ALL = 'user.view.all';
    // Able to view a single user
    static USER_VIEW_SINGLE = 'user.view.single';
    // Able to create a user
    static USER_CREATE = 'user.create';
    // Able to update a user
    static USER_UPDATE = 'user.update';
    // Able to delete a user
    static USER_DELETE = 'user.delete';
    // Able to restore a user
    static USER_RESTORE = 'user.restore';
    // Able to force delete a user
    static USER_FORCE_DELETE = 'user.force_delete';
    // Able to lock/unlock a user
    static USER_LOCKING = 'user.locking';
    // Able to manage nurse users (create, update, delete), not able to force delete, restore or lock
    static USER_MANAGE_NURSE = 'user.manage.nurse';
    // Able to manage specialist nurse users (create, update, delete), not able to force delete, restore or lock
    static USER_MANAGE_SPECIALIST_NURSE = 'user.manage.specialist_nurse';
    // 
    static USER_MANAGE_SUPPLIER = 'user.manage.supplier';
    // Able to manage finance users (create, update, delete), not able to force delete, restore or lock
    static USER_MANAGE_FINANCE = 'user.manage.finance';
    // Able to manage pharmacy users (create, update, delete), not able to force delete, restore or lock
    static USER_MANAGE_PHARMACIST = 'user.manage.pharmacist';
    // Able to manage admin users (create, update, delete), not able to force delete, restore or lock
    static USER_MANAGE_ADMIN = 'user.manage.admin';
    // Able to manage authoriser users (create, update, delete), not able to force delete, restore or lock
    static USER_MANAGE_AUTHORISER = 'user.manage.authoriser';
    // Able to manage multi location nurse users (create, update, delete), not able to force delete, restore or lock
    static USER_MANAGE_MULTI_LOCATION_NURSE = 'user.manage.multi_location_nurse';
    // Able to manage multi ccg authoriser users (create, update, delete), not able to force delete, restore or lock
    static USER_MANAGE_MULTI_CCG_AUTHORISER = 'user.manage.multi_ccg_authoriser';
    // Able to view related Formulary Classification and Location information
    static USER_FORMULARY_VIEWER_VIEW = 'user.formulary_viewer.view';
    // 
    static USER_SUBORDER_VIEW_ALL = 'user.suborder.view.all';
    // Able to view all accessible suborders (Owned or from locations assigned)
    static USER_SUBORDER_VIEW_ALL_ACCESSIBLE = 'user.suborder.view.all.accessible';
    // Able to view a single accessible suborder (Owned or from locations assigned)
    static USER_SUBORDER_VIEW_SINGLE_ACCESSIBLE = 'user.suborder.view.single.accessible';
    // Able to fully manage product overrides
    static CCG_PRODUCT_OVERRIDE_BYPASS = 'ccg_product_override.bypass';
    // Able to view all product overrides
    static CCG_PRODUCT_OVERRIDE_VIEW_ALL = 'ccg_product_override.view.all';
    // Able to view single product overrides
    static CCG_PRODUCT_OVERRIDE_VIEW_SINGLE = 'ccg_product_override.view.single';
    // Able to create product overrides
    static CCG_PRODUCT_OVERRIDE_CREATE = 'ccg_product_override.create';
    // Able to update product overrides
    static CCG_PRODUCT_OVERRIDE_UPDATE = 'ccg_product_override.update';
    // Able to delete product overrides
    static CCG_PRODUCT_OVERRIDE_DELETE = 'ccg_product_override.delete';
    // Able to force delete product overrides
    static CCG_PRODUCT_OVERRIDE_FORCE_DELETE = 'ccg_product_override.force_delete';
    // Able to restore product overrides
    static CCG_PRODUCT_OVERRIDE_RESTORE = 'ccg_product_override.restore';
    // Able to fully manage CMS containers
    static CMS_CONTAINER = 'cms_container';
    // Able to view all CMS containers
    static CMS_CONTAINER_VIEW_ANY = 'cms_container.view.any';
    // Able to view a single CMS container
    static CMS_CONTAINER_VIEW_SINGLE = 'cms_container.view.single';
    // Able to create a CMS container
    static CMS_CONTAINER_CREATE = 'cms_container.create';
    // Able to update a CMS container
    static CMS_CONTAINER_UPDATE = 'cms_container.update';
    // Able to delete a CMS container
    static CMS_CONTAINER_DELETE = 'cms_container.delete';
    // Able to force delete a CMS container
    static CMS_CONTAINER_FORCE_DELETE = 'cms_container.force_delete';
    // Able to restore a CMS container
    static CMS_CONTAINER_RESTORE = 'cms_container.restore';
    // Able to fully manage there CCG CMS containers
    static CMS_CONTAINER_CCG_MANAGE = 'cms_container.ccg.manage';
    // Able to view all cms containers for the CCG there assigned to
    static CMS_CONTAINER_CCG_VIEW = 'cms_container.ccg.view';
    // Able to view all cms news containers for the CCG there assigned to
    static CMS_CONTAINER_NEWS_CCG_MANAGE = 'cms_container.news.ccg.manage';
    // Able to view single cms news containers for the CCG there assigned to
    static CMS_CONTAINER_NEWS_CCG_VIEW = 'cms_container.news.ccg.view';
    // Able to view all cms education containers for the CCG there assigned to
    static CMS_CONTAINER_EDUCATION_CCG_MANAGE = 'cms_container.education.ccg.manage';
    // Able to view single cms education containers for the CCG there assigned to
    static CMS_CONTAINER_EDUCATION_CCG_VIEW = 'cms_container.education.ccg.view';
    // Able to view all cms page containers for the CCG there assigned to
    static CMS_CONTAINER_PAGE_CCG_MANAGE = 'cms_container.page.ccg.manage';
    // Able to view single cms page containers for the CCG there assigned to
    static CMS_CONTAINER_PAGE_CCG_VIEW = 'cms_container.page.ccg.view';
    // 
    static CMS_CONTAINER_PAGE_MANAGE = 'cms_container.page.manage';
    // 
    static CMS_CONTAINER_NEWS_MANAGE = 'cms_container.news.manage';
    // 
    static CMS_CONTAINER_EDUCATION_MANAGE = 'cms_container.education.manage';
    // Able to fully manage CMS container comments
    static CMS_CONTAINER_COMMENT = 'cms_container_comment.bypass';
    // Able to view all CMS container comments
    static CMS_CONTAINER_COMMENT_VIEW_ALL = 'cms_container_comment.view.all';
    // Able to view a single CMS container comment
    static CMS_CONTAINER_COMMENT_VIEW_SINGLE = 'cms_container_comment.view.single';
    // Able to create a CMS container comment
    static CMS_CONTAINER_COMMENT_CREATE = 'cms_container_comment.create';
    // Able to update a CMS container comment
    static CMS_CONTAINER_COMMENT_UPDATE = 'cms_container_comment.update';
    // Able to delete a CMS container comment
    static CMS_CONTAINER_COMMENT_DELETE = 'cms_container_comment.delete';
    // Able to force delete a CMS container comment
    static CMS_CONTAINER_COMMENT_FORCE_DELETE = 'cms_container_comment.force_delete';
    // Able to restore a CMS container comment
    static CMS_CONTAINER_COMMENT_RESTORE = 'cms_container_comment.restore';
    // Able to fully manage files
    static FILE_BYPASS = 'file.bypass';
    // Able to view all files
    static FILE_VIEW_ALL = 'file.view.all';
    // Able to view single files
    static FILE_VIEW_SINGLE = 'file.view.single';
    // Able to create / upload files
    static FILE_CREATE = 'file.create';
    // Able to update files
    static FILE_UPDATE = 'file.update';
    // Able to delete files
    static FILE_DELETE = 'file.delete';
    // Able to force delete files
    static FILE_FORCE_DELETE = 'file.force_delete';
    // Able to restore files
    static FILE_RESTORE = 'file.restore';
    // Able to fully manage marketing opt ins
    static MARKETING_OPT_IN_BYPASS = 'marketing_opt_in.bypass';
    // Able to view all marketing opt ins
    static MARKETING_OPT_IN_VIEW_ALL = 'marketing_opt_in.view.all';
    // Able to view single marketing opt ins
    static MARKETING_OPT_IN_VIEW_SINGLE = 'marketing_opt_in.view.single';
    // Able to create / upload marketing opt ins
    static MARKETING_OPT_IN_CREATE = 'marketing_opt_in.create';
    // Able to update marketing opt ins
    static MARKETING_OPT_IN_UPDATE = 'marketing_opt_in.update';
    // Able to delete marketing opt ins
    static MARKETING_OPT_IN_DELETE = 'marketing_opt_in.delete';
    // Able to force delete marketing opt ins
    static MARKETING_OPT_IN_FORCE_DELETE = 'marketing_opt_in.force_delete';
    // Able to restore marketing opt ins
    static MARKETING_OPT_IN_RESTORE = 'marketing_opt_in.restore';
    // Able to fully manage Orders
    static ORDER_BYPASS = 'order.bypass';
    // Able to view all orders
    static ORDER_VIEW_ALL = 'order.view.all';
    // Able to view single orders
    static ORDER_VIEW_SINGLE = 'order.view.single';
    // Able to create orders
    static ORDER_CREATE = 'order.create';
    // Able to update orders
    static ORDER_UPDATE = 'order.update';
    // Able to delete orders
    static ORDER_DELETE = 'order.delete';
    // Able to force delete orders
    static ORDER_FORCE_DELETE = 'order.force_delete';
    // Able to restore orders
    static ORDER_RESTORE = 'order.restore';
    // 
    static ORDER_ASSIGNED_VIEW_ALL = 'order.assigned.view.all';
    // Able to fully manage Order products
    static ORDER_PRODUCT_BYPASS = 'order_product.bypass';
    // Able to view all order products
    static ORDER_PRODUCT_VIEW_ALL = 'order_product.view.all';
    // Able to view single order product
    static ORDER_PRODUCT_VIEW_SINGLE = 'order_product.view.single';
    // Able to create order product
    static ORDER_PRODUCT_CREATE = 'order_product.create';
    // Able to update order product
    static ORDER_PRODUCT_UPDATE = 'order_product.update';
    // Able to delete order product
    static ORDER_PRODUCT_DELETE = 'order_product.delete';
    // Able to force delete order product
    static ORDER_PRODUCT_FORCE_DELETE = 'order_product.force_delete';
    // Able to restore order product
    static ORDER_PRODUCT_RESTORE = 'order_product.restore';
    // Able to fully manage Location Authorisers
    static LOCATION_AUTHORISER_BYPASS = 'location_authorisers.bypass';
    // Able to view all Location Authorisers
    static LOCATION_AUTHORISER_VIEW_ALL = 'location_authorisers.view.all';
    // Able to create Location Authorisers
    static LOCATION_AUTHORISER_CREATE = 'location_authorisers.create';
    // Able to update Location Authorisers
    static LOCATION_AUTHORISER_UPDATE = 'location_authorisers.update';
    // Able to delete Location Authorisers
    static LOCATION_AUTHORISER_DELETE = 'location_authorisers.delete';
    // Able to fully manage held orders
    static HELD_ORDER_BYPASS = 'held_order.bypass';
    // Able to view all held orders
    static HELD_ORDER_VIEW_ALL = 'held_order.view.all';
    // Able to authorise held orders
    static HELD_ORDER_UPDATE = 'held_order.update';
    // Able to delete held orders
    static HELD_ORDER_DELETE = 'held_order.delete';
    // Able to force delete orders
    static HELD_ORDER_FORCE_DELETE = 'held_order.force_delete';
    // Able to restore deleted held orders
    static HELD_ORDER_RESTORE = 'held_order.restore';
    // 
    static HELD_ORDER_APPROVE = 'held_order.approve';
    // 
    static ORDER_AUTHORISATIONS_APPROVE = 'order.authorisation.';
    // Able to create orders for any location there assigned to
    static ORDER_PROCESS_CREATE = 'order.process.create';
    // Able to create orders for there primary location
    static ORDER_PROCESS_CREATE_PRIMARY_LOCATION = 'order.process.create.primary_location';
    // Able to see and order specialist only products
    static ORDER_PROCESS_ACCESS_SPECIALIST_PRODUCTS = 'order.process.access_specialist_products';
    // Able to forward a suborder thats been accepted
    static ORDER_PROCESS_SUBORDER_FORWARD = 'order.process.suborder.forward';
    // Able cancel order before being accepted
    static ORDER_PROCESS_CANCEL = 'order.process.cancel';
    // Able to manage supplier suborder notes
    static ORDER_PROCESS_SUBORDER_NOTE = 'order.process.note';
    // Able to mark suborder user action as completed
    static ORDER_PROCESS_SUBORDER_USER_ACTION = 'order.process.user_action';
    // Able to approve held orders that require product and or budget auth
    static ORDER_PROCESS_APPROVE = 'order.process.approve';
    // Able to approve held orders that require product auth
    static ORDER_PROCESS_APPROVE_PRODUCT_AUTHORISATION = 'order.process.approve.product_authorisation';
    // Able to approve held orders that require budget auth
    static ORDER_PROCESS_APPROVE_BUDGET_AUTHORISATION = 'order.process.approve.budget_authorisation';
    // 
    static ORDER_PROCESS_ORDER_AUTHORISATIONS_VIEW = 'order.process.order_authorisations.view';
    // 
    static ORDER_PROCESS_ORDER_AUTHORISATIONS_APPROVE_ANY = 'order.process.order_authorisations.approve.any';
    // 
    static ORDER_PROCESS_ORDER_AUTHORISATIONS_APPROVE_ASSIGNED_LOCATIONS = 'order.process.order_authorisations.approve.assigned_locations';
    // Able to mark suborders as accepted
    static ORDER_PROCESS_SUBORDER_UPDATE_STATUS_ACCEPTED = 'order.process.suborder.update_status.accepted';
    // Able to mark a suborder as shipped
    static ORDER_PROCESS_SUBORDER_UPDATE_STATUS_SHIPPED = 'order.process.suborder.update_status.shipped';
    // Able to mark suborder as received
    static ORDER_PROCESS_SUBORDER_UPDATE_STATUS_RECEIVED = 'order.process.suborder.update_status.received';
    // Able to mark suborder as processing
    static ORDER_PROCESS_SUBORDER_UPDATE_STATUS_PAID = 'order.process.suborder.update_status.paid';
    // Able to fully manage invoices
    static INVOICE_BYPASS = 'invoice.bypass';
    // Able to view all invoices
    static INVOICE_VIEW_ALL = 'invoice.view.all';
    // Able to view single invoices
    static INVOICE_VIEW_SINGLE = 'invoice.view.single';
    // Able to create invoices
    static INVOICE_CREATE = 'invoice.create';
    // Able to update invoices
    static INVOICE_UPDATE = 'invoice.update';
    // Able to delete invoices
    static INVOICE_DELETE = 'invoice.delete';
    // Able to force delete invoices
    static INVOICE_FORCE_DELETE = 'invoice.force_delete';
    // Able to restore invoices
    static INVOICE_RESTORE = 'invoice.restore';
    // Able to view all invoices for there locations
    static INVOICE_VIEW_LOCATIONS = 'invoice.view.locations';
    // Able to view all location, only from primary location
    static INVOICE_VIEW_PRIMARY_LOCATION = 'invoice.view.primary_location';
    // Able to view all invoices for there supplier
    static INVOICE_VIEW_SUPPLIER = 'invoice.view.supplier';
    // Allows user to see orders at there primary location
    static ORDER_VIEW_LOCATIONS = 'order.view.locations';
    // Allows user to see orders at all assigned locations
    static ORDER_VIEW_PRIMARY_LOCATION = 'order.view.primary_location';
    // Able to do invoicing for the supplier they are assigned to
    static INVOICE_INVOICING_PHARMACY = 'invoice.invoicing.pharmacy';
    // Able to do invoicing for all locations they are assigned to
    static INVOICE_INVOICING_FINANCE = 'invoice.invoicing.finance';
    // Able to fully manage options
    static OPTION_BYPASS = 'option.bypass';
    // Able to view all options
    static OPTION_VIEW_ALL = 'option.view.all';
    // Able to create options
    static OPTION_CREATE = 'option.create';
    // Able to update options
    static OPTION_UPDATE = 'option.update';
    // Able to delete options
    static OPTION_DELETE = 'option.delete';
    // Allows the user to have many locations assigned to them
    static MULTI_LOCATION = 'location.multi';
    // Allows the user to have many CCGs assigned to them
    static MULTI_CCG = 'ccg.multi';
    // Allows full reporting management and generation
    static REPORTING_BYPASS = 'reporting.bypass';
    // Allows reporting to show in the users menu
    static REPORTING_ALLOWED = 'reporting.allowed';
    // N/A
    static REPORTING_LICENSES_ALLOWED = 'reportingLicenses.allowed';
    // Allow a user to view all reporting licenses
    static REPORTING_LICENSES_VIEW_ANY = 'reportingLicenses.view.any';
    // Allow a user to view a single reporting license
    static REPORTING_LICENSES_VIEW_SINGLE = 'reportingLicenses.view.single';
    // Allow a user to create a reporting license
    static REPORTING_LICENSES_CREATE = 'reportingLicenses.create';
    // Allow a user to edit a reporting license
    static REPORTING_LICENSES_EDIT = 'reportingLicenses.edit';
    // Allow a user to delete a reporting license
    static REPORTING_LICENSES_DELETE = 'reportingLicenses.delete';
    // Allow a user to restore a reporting license
    static REPORTING_LICENSES_RESTORE = 'reportingLicenses.restore';
    // Allow a user to update a reporting license
    static REPORTING_LICENSES_UPDATE = 'reportingLicenses.update';
    // Allow a user manage reporting licenses
    static REPORTING_LICENSES = 'reportingLicenses';
    // Allow a user to force delete a reporting license
    static REPORTING_LICENSES_FORCE_DELETE = 'reportingLicenses.force_delete';
    // Allows a user to use the assigned location report blueprint
    static REPORTING_ASSIGNED_LOCATIONS_REPORT_BLUEPRINT = 'reporting.assigned_locations_report.blueprint';
    // Allows a user to use the location report blueprint
    static REPORTING_LOCATION_REPORT_BLUEPRINT = 'reporting.location_report.blueprint';
    // Allows a user to use the assigned ccgs report blueprint
    static REPORTING_ASSIGNED_CCGS_REPORT_BLUEPRINT = 'reporting.assigned_ccgs_report.blueprint';
    // Allows a user to use the ccg report blueprint
    static REPORTING_CCGS_REPORT_BLUEPRINT = 'reporting.ccg_report.blueprint';
    // Allows a user to use the assigned locations type report blueprint
    static REPORTING_ASSIGNED_LOCATIONS_TYPE_REPORT_BLUEPRINT = 'reporting.assigned_locations_type_report.blueprint';
    // Allows a user to use the location type report blueprint
    static REPORTING_LOCATION_TYPE_REPORT_BLUEPRINT = 'reporting.location_type_report.blueprint';
    // Able to view all stocktakes
    static STOCKTAKE_VIEW_ALL = 'stocktake.view.all';
    // Allows full management over exports
    static EXPORT_BYPASS = 'export.bypass';
    // Allows a user to view all exports site wide
    static EXPORT_VIEW_ALL = 'export.view.all';
    // Allows a user to create exports
    static EXPORT_CREATE = 'export.create';
    // Allows a user to delete exports
    static EXPORT_DELETE = 'export.delete';
    // Allows a user to download exports
    static EXPORT_DOWNLOAD = 'export.download';
    // Allows a user to create exports
    static EXPORT_ALLOW_EXPORTS = 'export.allow_exports';
    // Allows a user to create exports for locations
    static EXPORT_ORDERS_LOCATIONS = 'export.orders.locations';
    // Allows a user to create exports for ccgs
    static EXPORT_ORDERS_CCGS = 'export.orders.ccgs';
    // Allows a user to create exports for finance invoicing
    static EXPORT_FINANCE_INVOICING = 'export.finance_invoicing';
    // Allows a user to create exports for pharmacy invoicing
    static EXPORT_PHARMACY_INVOICING = 'export.pharmacy_invoicing';
    // Ability to export using the 'Location' blueprint.
    static IO_EXPORT_LOCATION = 'io.export.location';
    // Ability to export using the 'Channel Products' blueprint.
    static IO_EXPORT_CHANNEL_PRODUCTS = 'io.export.channel_products';
    // Ability to export using the 'CCG Order' blueprint.
    static IO_EXPORT_CCG_ORDER = 'io.export.ccg_order';
    // Ability to export using the 'CCG Location' blueprint.
    static IO_EXPORT_CCG_LOCATION = 'io.export.ccg_location';
    // Ability to export using the 'Users: CCG' blueprint.
    static IO_EXPORT_USERS_CCG = 'io.export.users_ccg';
    // Ability to export using the 'Users: Location' blueprint.
    static IO_EXPORT_USERS_LOCATION = 'io.export.users_location';
    // Ability to export using the Formulary Classification Product blueprint.
    static IO_EXPORT_FORMULARY_CLASSIFICATION_PRODUCTS = 'io.export.formulary_classification_products';
    // Ability to export using the Full CCG Location blueprint.
    static IO_EXPORT_FULL_CCG_LOCATION = 'io.export.full_ccg_location';
    // Ability to export using the 'System Events' blueprint.
    static IO_EXPORT_SYSTEM_EVENTS = 'io.export.system_events';
    // Ability to export using the 'Daylong Formulary Products' blueprint.
    static IO_IMPORT_DAYLONG_FORMULARY_PRODUCTS = 'io.import.daylong_formulary_products';
    // Ability to export using the Daylong Product blueprint.
    static IO_IMPORT_DAYLONG_PRODUCTS = 'io.import.daylong_products';
    // Ability to export using the 'Locations' blueprint.
    static IO_IMPORT_LOCATIONS = 'io.import.locations';
    // Ability to export using the 'Formulary Classification Products' blueprint.
    static IO_IMPORT_FORMULARY_CLASSIFICATION_PRODUCTS = 'io.import.formulary_classification_products';
    // Ability to export using the 'Users' blueprint.
    static IO_IMPORT_USERS = 'io.import.users';
    // Ability to export using the 'Formeo Products' blueprint.
    static IO_IMPORT_FORMEO_PRODUCTS = 'io.import.formeo_products';
    
}
export default Permissions;
